import React, {
  useState,
  useCallback,
  useEffect,
  useRef,
  useReducer,
  useMemo,
  Children,
} from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { Button, ButtonBase } from '@material-ui/core';
import moment from 'moment';
import {
  sideMenuIsOpenUpdate,
  sideMenuComponentUpdate,
  GlobalHistory,
  bottomBoxComponentUpdate,
  havePermissionToViewDetails,
  havePermissionToEditInformation,
  getSideMenuStatus,
  getSideMenuComponent,
  returnPropsByPermissions,
  showSuccess,
  generateUniqueKey,
} from '../../../Helper';
import {
  ActionsButtonsComponent,
  ViewTypes,
  AutocompleteComponent,
  SelectComponet,
  Spinner,
  Inputs,
  DialogComponent,
} from '../../../Components';
import {
  ActionsEnum,
  ViewTypesEnum,
  TableActions,
  ActionsButtonsEnum,
  FormsIdsEnum,
  UnitsFilterStatusEnum,
  TableFilterOperatorsEnum,
  TableFilterTypesEnum,
  ArrayOFSearchableFormFields,
  ListingAgentIdsEnum,
  DateFilterTypesEnum,
  SearchCriteriaEnum,
  AddressEnum,
} from '../../../Enums';
import { AdvanceSearchSecondVersion } from '../../../SharedComponents/AdvanceSearchSecondVersion';
import {
  CardDetailsComponent,
  UnitsCardsComponent,
  UnitsLeaseTableComponent,
} from './UnitsLeaseUtilities';
import {
  GetAllSearchableFormFieldsByFormId,
  GetAdvanceSearchLeaseUnitsPropertyManagement,
  UnitsAdvanceSearchTest,
  GetAllFormFieldsByFormId,
  GetLookupItems,
  GetUnitDetails,
  IsNeedApprovalMessageInMarketing,
  GetAllRolesByUserId,
  GetLookupItemsByLookupTypeName,
  getProperties,
  lookupItemsGetId,
  GetUnitsRefNumbers,
  PropertiesAdvanceSearchByUnits,
  GetAllSystemTemplateByCategoryId,
  GetFieldsNeedingApprovalForChange,
} from '../../../Services';
import { PaginationComponent } from '../../../Components/PaginationComponent/PaginationComponent';
import { UnitsImportDialog } from './UnitsLeaseUtilities/Dialogs/UnitsImportDialog/UnitsImportDialog';
import { AdvanceSearch } from '../../../SharedComponents/AdvanceSearch/AdvanceSearch';
import { UnitMapper } from './UnitLeaseMapper';
import { ActiveItemActions } from '../../../store/ActiveItem/ActiveItemActions';
import { GlobalAdvanceSearchActions } from '../../../store/GlobalAdvanceSearch/GlobalAdvanceSearchActions';
import { useTitle } from '../../../Hooks';
import { GlobalOrderFilterActions } from '../../../store/GlobalOrderFilter/GlobalOrderFilterActions';
import { DateRangePickerComponent } from '../../../Components/Controls/DateRangePickerComponent/DateRangePickerComponent';
import { UnitsLeasePermissions } from '../../../Permissions/Lease/UnitsLeasePermissions';
import { UnitPermissions } from '../../../Permissions/PropertyManagement';
import { LeaseTransactionJourneyPermissions } from '../../../Permissions';
import { PermissionsComponent } from '../../../Components/PermissionsComponent/PermissionsComponent';
import { getIsAllowedPermission } from '../../../Helper/Permissions.Helper';
import { UnitsLeaseTableHeaderData } from './UnitsLeaseUtilities/UnitsLeaseTableComponent/UnitsLeaseTableHeaderData';
import {
  UnitsVerticalTabsData,
  UnitsVerticalTabsDataUnitsPropertyManagement,
} from '../Common/OpenFileView/OpenFileUtilities/OpenFileData';
import { ActivitiesManagementDialog } from '../../../SharedComponents/ActivitiesManagementDialog/ActivitiesManagementDialog';
import { useScrollToElement } from '../../../Hooks/useScrollToElement';
import {
  NeedsApprovalDialogBulkUnit,
  OwnerDetailsDialog,
  UnitsBulkStatusUpdateDialog,
} from '../UnitsSalesView/UnitsSalesUtilities/Dialogs';
import { TransactionUnitSelectionDialog } from '../LeaseTransactionJourney/TransactionSteps';
import UnitsMapView from '../../../SharedComponents/UnitsMapView';
import { StaticLookupsIds } from '../../../assets/json/StaticLookupsIds';
import UnitsByProperty from '../UnitsSalesView/UnitsSalesUtilities/UnitsByProperty';
import UnitCard from '../UnitsSalesView/UnitsSalesUtilities/UnitsByProperty/UnitCard';
import { UnitTemplateDialogPreviewDialog } from '../UnitsView/UnitsProfileManagementView/Dialogs/UnitTemplateDialog/UnitTemplateDialogPreviewDialog';
import { FavoriteDFM } from '../../DFMSharedComponents/FavoriteDFM/FavoriteDFM.View';
import { FieldsNeedsApprovalDialogBulkUnits } from '../UnitsSalesView/UnitsSalesUtilities/Dialogs/UnitsBulkStatusUpdateDialog/FieldsNeedsApprovalDialogBulkUnits';
import { RemoveLeadsOrUnitsFromFolder } from '../../../Services/FavoriteFoldersServices';
import { useUnitValidationContext } from '../../../Contexts/UnitValidationContext/UnitValidationContext';
import useSmartProposalActions from '../SmartProposal/Hooks/useProposalStart';
import RequestOfferLetterDialog from './UnitsLeaseUtilities/Dialogs/RequestActivityAutomation/RequestActivityAutomationDialog';
import PriceNegotiationDialog from './UnitsLeaseUtilities/Dialogs/PriceNegotiationDialog/PriceNegotiationDialog';
import ProposalStartButton from '../SmartProposal/Utilities/ProposalThemeDialog/ProposalStartButton';
import { ArchiveWizard } from '../../DFMSharedComponents/ArchiveWizardDialog/ArchiveWizardDialog';

const parentTranslationPath = 'UnitsView';
const translationPath = '';
export const UnitsLeaseView = () => {
  const { t } = useTranslation(parentTranslationPath);
  const reducer = useCallback((state, action) => {
    if (action.id !== 'edit') return { ...state, [action.id]: action.value };
    return {
      ...action.value,
    };
  }, []);
  useTitle(t(`${translationPath}units`));
  const [data, setData] = useReducer(reducer, {
    propertyName: [],
    community: [],
    unitType: [],
    unitRef: [],
  });
  const { toggleUnitValidationDialog, setIsFromProperty } =
    useUnitValidationContext();
  const dateRangeDefault = {
    startDate: null,
    endDate: null,
    key: 'selection',
    selectedDateType: 1,
  };
  const [isLoadingLeadOwner, setIsLoadingLeadOwner] = useState(false);
  const itemData = useSelector((state) => state.ActiveItemReducer);
  const [MPIFilterValue, setMPIFilterValue] = useState(null);
  const [selected, setSelected] = useReducer(reducer, {
    propertyName: null,
    community: null,
    unitType: null,
    unitRefNo: null,
  });
  const [isLoadingAllUnits, setIsLoadingAllUnits] = useState(false);
  const [ownerDetailsDialog, setOwnerDetailsDialog] = useState({
    isOpen: false,
    titleText: '',
  });
  const [isDialogRequestActivityOpen, setIsDialogRequestActivityOpen] =
    useState(false);
  const [leadOwnerDetails, setLeadOwnerDetails] = useState({});
  const [isTransactionStartOpen, setIsTransactionStartOpen] = useState(false);
  const [unitsBulkStatusUpdateIsOpen, setUnitsBulkStatusUpdateIsOpen] =
    useState(false);
  const [unitsIdUpdateArray, setUnitsIdUpdateArray] = useState([]);
  const [viewType, setViewType] = useState('');
  const [isPublishedUnits, setIsPublishedUnits] = useState(false);
  const [isPropertyManagementView, setIsPropertyManagementView] =
    useState(false);
  const pathName = window.location.pathname
    .split('/home/')[1]
    .split('/view')[0];
  const dispatch = useDispatch();
  const [addActivity, setAddActivity] = useState(false);
  const [activeItem, setActiveItem] = useState(null);
  const orderFilter = useSelector((state) => state.GlobalOrderFilterReducer);
  const advanceSearch = useSelector(
    (state) => state.GlobalAdvanceSearchReducer
  );
  const [unitsTableFilter, setUnitsTableFilter] = useState(
    (advanceSearch && advanceSearch.UnitsLeaseFilter) || null
  );
  const [isSmartProposalActive, setIsSmartProposalActive] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isAllFormFieldsLoading, setIsAllFormFieldsLoading] = useState(false);
  const [isDatePickerChanged, setIsDatePickerChanged] = useState(false);
  const [activeActionType, setActiveActionType] = useState(
    (localStorage.getItem('ViewType') &&
      JSON.parse(localStorage.getItem('ViewType')).unitsLeaseView) ||
      ViewTypesEnum.cards.key
  );
  const [selectFieldsOnAdvanceSearch, setSelectFieldsOnAdvanceSearch] =
    useState([]);
  const [filterValuesFromAdvanceSearch, setFilterValuesFromAdvanceSearch] =
    useState(null);

  const [displyOpenFileButton, setDisplyOpenFileButton] = useState(false);
  const [displyEditButton, setDisplyEditButton] = useState(false);
  const [isDialogPriceNegotiatioOpen, setIsDialogPriceNegotiatioOpen] =
    useState(false);
  const [displyMatchingButton, setDisplyMatchingButton] = useState(false);
  const [searchedItem, setSearchedItem] = useState('');
  const searchTimer = useRef(null);
  const [isExpanded, setIsExpanded] = useState(
    activeActionType === ViewTypesEnum.cardsExpanded.key
  );
  const [allFormFields, setAllFormFields] = useState([]);
  const [unitStatus, setUnitStatus] = useState(
    orderFilter.UnitsLeaseStatus || [0]
  );
  const [unitsPortal, setUnitsPortal] = useState(
    orderFilter.PublishLeasePortal || [0]
  );
  const [selectedPropertyForMap, setSelectedPropertyForMap] = useState(null);
  const [unitsPropertyName, setUnitsPropertyName] = useState(null);
  const [unitsUnitType, setUnitsUnitType] = useState(null);
  const [unitsSaleType, setUnitsSaleType] = useState(null);
  const [unitsCommunity, setUnitsCommunity] = useState(null);
  const [map, setMap] = useState(undefined);
  const [isMapChanged, setIsMapChanged] = useState(false);
  const [mapKey, setMapKey] = useState(generateUniqueKey());
  const [fieldsNeedsApproval, setFieldsNeedsApproval] = useState([]);
  const [folderIdValue, setfolderIdValue] = useState(false);
  const [detailsPropertyByUnitsList, setDetailsPropertyByUnitsList] = useState(
    () => ({
      result: [],
      totalCount: 0,
    })
  );
  const [stopChangeCapturing, setStopChangeCapturing] = useState(false);
  const loginResponse = useSelector((state) => state.login.loginResponse);
  const [checkedCards, setCheckedCards] = useState([]);
  const [activeCard, setActiveCard] = useState(null);
  const [isOpenImportDialog, setIsOpenImportDialog] = useState(false);
  const [isClearFiltersClicked, setIsClearFiltersClicked] = useState(false);
  const [isAdvanceSearchCleared, setIsAdvanceSearchCleared] = useState(false);
  const [isAdvanceSearchActive, setIsAdvanceSearchActive] = useState(false);
  const [PortalData, setPortalData] = useState(null);
  const [savedRoles, setSavedRoles] = useState({});
  const [needsApprovalDialog, setNeedsApprovalDialog] = useState(false);
  const [fieldsNeedsApprovalDialog, setFieldsNeedsApprovalDialog] =
    useState(false);
  const [typeOfRequest, setTypeOfRequest] = useState(false);
  const [selectedOrderBy, setSelectedOrderBy] = useState({
    filterBy: orderFilter?.unitsSalesFilter?.filterBy,
    orderBy: orderFilter?.unitsSalesFilter?.orderBy,
  });
  const [orderBy, setOrderBy] = useState(
    selectedOrderBy.filterBy
      ? selectedOrderBy
      : { filterBy: 'createdOn', orderBy: 2 }
  );
  useSmartProposalActions({ proposalUnits: checkedCards });
  const [dateFilter, setDateFilter] = useState(
    (orderFilter &&
      orderFilter.UnitsleaseDate &&
      orderFilter.UnitsleaseDate.startDate &&
      orderFilter.UnitsleaseDate.endDat !== null && {
        startDate: new Date(
          (orderFilter &&
            orderFilter.UnitsleaseDate &&
            orderFilter.UnitsleaseDate.startDate) ||
            null
        ),
        endDate: new Date(
          (orderFilter &&
            orderFilter.UnitsleaseDate &&
            orderFilter.UnitsleaseDate.endDate) ||
            null
        ),
        key: new Date(
          (orderFilter &&
            orderFilter.UnitsleaseDate &&
            orderFilter.UnitsleaseDate.key) ||
            null
        ),
        selectedDateType:
          (orderFilter &&
            orderFilter.UnitsleaseDate &&
            orderFilter.UnitsleaseDate.selectedDateType) ||
          1,
      }) ||
      dateRangeDefault
  );

  const [checkedDetailedCards, setCheckedDetailedCards] = useState([]);
  const [detailsUnitsList, setDetailsUnitsList] = useState(() => ({
    result: [],
    totalCount: 0,
  }));
  const [SearchedItemUnitReferenceNumber, setSearchedItemUnitReferenceNumber] =
    useState('');
  const { setHash } = useScrollToElement(!!detailsUnitsList.result.length);
  const [searchableFormFields, setSearchableFormFields] = useState([]);
  const [searchData, setSearchData] = useState([]);
  const [activeSelectedAction, setActiveSelectedAction] = useState('');
  const [unitsCardsByProperty, setUnitCardsByProperty] = useState(false);
  const [selectedUnitsCards, setSelectedUnitsCards] = useState([]);
  const [isSelectedUnitDialogOpen, setIsSelectedUnitDialogOpen] =
    useState(false);
  const [templatesProposal, setTemplatesProposal] = useState([]);
  const [activeTemplateId, setActiveTemplateId] = useState(null);
  const [isProposalDialogOpen, setIsProposalDialogOpen] = useState(false);
  const [isSelectTemplateOpen, setIsSelectTemplateOpen] = useState(false);
  const [isOpenFavouriteDialog, setisOpenFavouritDialog] = useState(false);
  const [filterSearchDto, setFilterSearchDto] = useState(null);
  const [advanceSearchBtn, setAdvanceSearchBtn] = useState(true);
  const [searchInputValue, setSearchInputValue] = useState('');
  const [filter, setFilter] = useState({
    pageSize: parseInt(localStorage.getItem('Pagination')) || 25,
    pageIndex:
      JSON.parse(localStorage.getItem('unitsLeaseCurrentPageIndex')) || 0,
    search: '',
  });
  const [isFirst, setFirst] = useState(false);
  const [isFirst1, setFirst1] = useState(false);
  const [unitPublishStatus, setUnitPublishStatus] = useState(
    orderFilter.UnitLeasePublishStatusFilter || 0
  );
  const [ArchiveWizardDialog, setArchiveWizardDialog] = useState(false);
  const [actionButtonsKey, setActionButtonsKey] = useState(generateUniqueKey());
  const unitOperationSource = {
    sale: {
      key: 1,
    },
    lease: {
      key: 2,
    },
  };
  const isMapView = useMemo(
    () => activeActionType === ViewTypesEnum.map.key,
    [activeActionType]
  );

  const searchHandler = (data) => {
    const newValue = [
      {
        key: 'Address',
        title: 'Address',
        value: data,
      },
    ];
    if (searchTimer.current) clearTimeout(searchTimer.current);

    if (data === '') {
      const index = searchData.findIndex((item) => item.key === 'Address');
      if (index !== -1) searchData.splice(index, 1);
      setFilterSearchDto(null);
      localStorage.removeItem('UnitsLeaseFilter');
    } else {
      searchTimer.current = setTimeout(() => {
        setSearchData([...newValue]);
        setFilterSearchDto({
          Address: [
            {
              value: data,
            },
          ],
        });
      }, 1300);
    }
  };

  const checkDuplicatedUnitsButton = useCallback(() => {
    GlobalHistory.push(`/home/units-lease/duplicated-units`);
  });

  const onTypeChanged = useCallback(
    (activeType) => {
      const ViewTypeData = JSON.parse(localStorage.getItem('ViewType'));
      if (ViewTypeData) {
        ViewTypeData.unitsLeaseView = activeType;
        localStorage.setItem('ViewType', JSON.stringify(ViewTypeData));
      } else
        localStorage.setItem(
          'ViewType',
          JSON.stringify({ unitsLeaseView: activeType })
        );

      setActiveActionType(activeType);
      setIsExpanded(activeType === ViewTypesEnum.cardsExpanded.key);
      sideMenuIsOpenUpdate(false);
      sideMenuComponentUpdate(null);
    },
    [setActiveActionType]
  );

  const onPageIndexChanged = (pageIndex) => {
    localStorage.setItem(
      'unitsLeaseCurrentPageIndex',
      JSON.stringify(pageIndex)
    );
    setFilter((item) => ({ ...item, pageIndex }));
    setActiveCard(null);
    sideMenuComponentUpdate(null);
    sideMenuIsOpenUpdate(false);
  };

  const restorePageIndex = useCallback(() => {
    const currentPageIndex = localStorage.getItem('unitsLeaseCurrentPageIndex');

    if (currentPageIndex) {
      const pageIndex = JSON.parse(currentPageIndex);
      setFilter((item) => ({ ...item, pageIndex }));
    }
  }, []);

  useEffect(() => {
    restorePageIndex();
  }, []);

  const onPageSizeChanged = (pageSize) => {
    setFilter((item) => ({ ...item, pageIndex: 0, pageSize }));
    setActiveCard(null);
    sideMenuComponentUpdate(null);
    sideMenuIsOpenUpdate(false);
  };

  const filterOnChange = (event, newValue) => {
    const emptyKeyIndex = newValue.findIndex((item) => !item.value);
    if (!searchInputValue && emptyKeyIndex !== -1) {
      newValue.splice(emptyKeyIndex, 1);
      return;
    }
    if (emptyKeyIndex !== -1) newValue[emptyKeyIndex].value = searchInputValue;
    if (
      filterSearchDto &&
      Object.keys(filterSearchDto).length > 0 &&
      newValue.length === 0
    ) {
      onPageIndexChanged(0);
      setFilterSearchDto(null);
    }
    setSearchData([...newValue]);
  };

  const getAllSearchableFormFieldsByFormId = useCallback(async () => {
    const result = await GetAllSearchableFormFieldsByFormId(
      FormsIdsEnum.units.id
    );
    if (
      !(result && result.data && result.data.ErrorId) &&
      result &&
      Array.isArray(result)
    ) {
      const res = result
        .filter(
          (item) =>
            item.isSearchable &&
            item.formFieldId !== ListingAgentIdsEnum.ListingAgent.formFieldId
        )
        .map((item) => ({
          key: item.searchableKey || item.displayPath,
          title: item.formFieldTitle,
        }))
        .concat(ArrayOFSearchableFormFields);
      setSearchableFormFields([
        { key: 'Address', title: 'Address' },
        { key: 'isFavorite', title: 'Is Favorite' },
        { key: 'propertyId', title: 'Property Id' },
        ...res,
      ]);
    } else setSearchableFormFields([]);
  }, []);

  const getAllProperties = async (value) => {
    const res = await getProperties({
      pageIndex: 0,
      pageSize: 25,
      search: value || '',
    });
    if (!(res && res.status && res.status !== 200)) {
      setData({ id: 'propertyName', value: res.result || [] });
    } else {
      setData({ id: 'propertyName', value: [] });
    }
  };

  const getLookupItemsByLookupTypeName = useCallback(async (LookupTypeName) => {
    const res = await GetLookupItemsByLookupTypeName({
      lookUpName: LookupTypeName,
      pageIndex: 1,
      pageSize: 150,
    });
    if (!(res && res.status && res.status !== 200))
      setData({ id: 'unitType', value: res.result || [] });
    else setData({ id: 'unitType', value: [] });
  }, []);

  const getCommunityType = useCallback(async () => {
    const res = await lookupItemsGetId({
      lookupTypeId: AddressEnum.community.lookupTypeId,
    });
    if (!(res && res.status && res.status !== 200))
      setData({ id: 'community', value: res || [] });
    else setData({ id: 'community', value: [] });
  }, []);

  const getUnitsData = useCallback(
    async (f) => {
      if (isLoadingAllUnits && isMapView) {
        return;
      }
      if (isMapView && !map) {
        return;
      }
      const isViewAllData =
        pathName === 'units-property-management'
          ? returnPropsByPermissions(
              UnitPermissions.ViewAndSearchInPropertyManagementUnits
                .permissionsId
            )
          : returnPropsByPermissions(
              UnitsLeasePermissions.ViewAndSearchInLeaseUnits.permissionsId
            );
      if (isViewAllData) {
        setIsLoadingAllUnits(true);
        const index = unitStatus.findIndex((el) => el === 0);
        if (index !== -1) unitStatus.splice(index, 1);
        if (unitStatus.length === 0) unitStatus.push(0);

        const indexPortal = unitsPortal.findIndex((el) => el === 0);
        if (indexPortal !== -1) unitsPortal.splice(indexPortal, 1);
        if (unitsPortal.length === 0) unitsPortal.push(0);

        const localFilterDto = f || filterSearchDto || {};

        const filterCreatedByRole = loginResponse.roles.find(
          (role) => role.rolesName === 'Filter Created By'
        );
        const filterListingAgentRole = loginResponse.roles.find(
          (role) => role.rolesName === 'Filter Listing Agent'
        );
        const filterDubaiTeamRole = loginResponse.roles.find(
          (role) => role.rolesName === 'Filter Dubai Team'
        );
        if (filterCreatedByRole) {
          localFilterDto.createdById = [
            {
              searchType: TableFilterOperatorsEnum.equal.key,
              value: loginResponse.userId,
            },
          ];
        }
        if (filterListingAgentRole) {
          localFilterDto.rent_listing_agent_id = [
            {
              searchType: TableFilterOperatorsEnum.equal.key,
              value: loginResponse.userId,
            },
          ];
        }
        if (filterDubaiTeamRole) {
          localFilterDto.city = [
            {
              searchType: TableFilterOperatorsEnum.equal.key,
              value: 'dubai',
            },
          ];
        }

        if (unitStatus && unitStatus.length >= 1 && unitStatus[0] !== 0) {
          if (pathName === 'units-lease') {
            localFilterDto.lease_status = unitStatus.map((item) => ({
              searchType: TableFilterOperatorsEnum.equal.key,
              value: (item || '').toLowerCase(),
            }));
          } else {
            localFilterDto.status = unitStatus.map((item) => ({
              searchType: TableFilterOperatorsEnum.equal.key,
              value: (item || '').toLowerCase(),
            }));
          }
        }
        if (MPIFilterValue && MPIFilterValue !== null) {
          localFilterDto.marketComparison = [MPIFilterValue];
        }
        if (unitsPortal && unitsPortal.length >= 1 && unitsPortal[0] !== 0) {
          localFilterDto.PortalId = [
            {
              searchType: TableFilterOperatorsEnum.equal.key,
              value: `${unitsPortal}`,
            },
          ];
        }
        if (unitsPropertyName) {
          localFilterDto.property_name = [
            {
              searchType: TableFilterOperatorsEnum.equal.key,
              value: `${unitsPropertyName}`,
            },
          ];
        }
        if (unitsUnitType) {
          localFilterDto.unit_type = [
            {
              searchType: TableFilterOperatorsEnum.equal.key,
              value: `${unitsUnitType}`,
            },
          ];
        }
        if (unitsSaleType) {
          localFilterDto.sale_type = [
            {
              searchType: TableFilterOperatorsEnum.equal.key,
              value: `${unitsSaleType}`,
            },
          ];
        }
        if (unitsCommunity) {
          localFilterDto.community = [
            {
              searchType: TableFilterOperatorsEnum.equal.key,
              value: `${unitsCommunity}`,
            },
          ];
        }

        if (unitPublishStatus) {
          if (unitPublishStatus === 1) {
            localFilterDto.publish_status = [
              {
                searchType: TableFilterOperatorsEnum.equal.key,
                value: true,
              },
            ];
          } else if (unitPublishStatus === 2) {
            localFilterDto.publish_status = [
              {
                searchType: TableFilterOperatorsEnum.equal.key,
                value: false,
              },
            ];
          }
        }

        if (unitsTableFilter) {
          Object.values(unitsTableFilter)
            .filter((item) => item.searchableKey || item.displayPath)
            .map((item) => {
              if (localFilterDto[item.searchableKey || item.displayPath]) {
                localFilterDto[item.searchableKey || item.displayPath].push({
                  searchType: item.operator,
                  value: item.value,
                });
              } else if (item.value) {
                localFilterDto[item.searchableKey || item.displayPath] = [
                  {
                    searchType: item.operator,
                    value: item.value,
                  },
                ];
              } else if (
                !item.value &&
                (item.operator === TableFilterOperatorsEnum.isNotBlank.key ||
                  item.operator === TableFilterOperatorsEnum.isBlank.key)
              ) {
                localFilterDto[item.searchableKey || item.displayPath] = [
                  {
                    searchType: item.operator,
                    value: null,
                  },
                ];
              }
              return undefined;
            });
        }

        if (Object.values(localFilterDto).length)
          setIsAdvanceSearchActive(true);
        else setIsAdvanceSearchActive(false);

        const body = {
          criteria: localFilterDto,
          ...orderBy,
          operationType: 'Lease',
        };

        setIsDatePickerChanged(false);

        if (dateFilter && dateFilter.startDate && dateFilter.endDate) {
          const fromDate = moment(dateFilter.startDate)
            .startOf('day')
            .format('YYYY-MM-DDTHH:mm:ss');
          const toDate = moment(dateFilter.endDate).format(
            'YYYY-MM-DDTHH:mm:ss'
          );

          if (
            dateFilter.selectedDateType ===
            DateFilterTypesEnum.CreatedOnDate.key
          ) {
            body.fromDate = fromDate;
            body.toDate = toDate;
          } else if (
            dateFilter.selectedDateType ===
            DateFilterTypesEnum.UpdatedOnDate.key
          ) {
            body.updatedFromDate = fromDate;
            body.updatedToDate = toDate;
          } else if (
            dateFilter.selectedDateType === DateFilterTypesEnum.ListingDate.key
          ) {
            body.fromListingDate = fromDate;
            body.toListingDate = toDate;
          } else if (
            dateFilter.selectedDateType === DateFilterTypesEnum.PublishDate.key
          ) {
            body.fromPublishDate = fromDate;
            body.toPublishDate = toDate;
          } else if (
            dateFilter.selectedDateType ===
            DateFilterTypesEnum.ExpiredListingDate.key
          ) {
            body.fromExpiryListingDate = fromDate;
            body.toExpiryListingDate = toDate;
          } else if (
            dateFilter.selectedDateType ===
            DateFilterTypesEnum.LeaseTransactedDate.key
          ) {
            body.fromTransactedDate = fromDate;
            body.toTransactedDate = toDate;
          } else if (
            dateFilter.selectedDateType ===
            DateFilterTypesEnum.LeaseReservedTransactionDate.key
          ) {
            body.fromReservedDate = fromDate;
            body.toReservedDate = toDate;
          }
        }

        const propertyBody = { ...body, map };

        if (
          isMapView &&
          (!unitsCardsByProperty || isMapChanged || !advanceSearchBtn)
        ) {
          if (!!Object.keys(propertyBody.criteria).length) {
            delete propertyBody.map;
            setStopChangeCapturing(true);
          } else {
            setStopChangeCapturing(false);
          }
        }

        if (
          !body.criteria.property_name &&
          selectedPropertyForMap &&
          !getSideMenuStatus()
        ) {
          body.criteria.property_name = [
            { value: selectedPropertyForMap.value, searchType: 1 },
          ];
        }

        const res =
          isMapView &&
          (!unitsCardsByProperty || isMapChanged || !advanceSearchBtn)
            ? await PropertiesAdvanceSearchByUnits(filter, propertyBody)
            : pathName === 'units-property-management'
            ? await GetAdvanceSearchLeaseUnitsPropertyManagement(filter, body)
            : await UnitsAdvanceSearchTest(filter, body);

        if (!(res && res.status && res.status !== 200)) {
          if (
            isMapView &&
            (!unitsCardsByProperty || isMapChanged || !advanceSearchBtn)
          ) {
            setDetailsPropertyByUnitsList({
              result: res.result,
              totalCount: res?.totalCount ?? 0,
            });
          } else {
            setDetailsUnitsList({
              result: ((res && res.result) || []).map(
                (item) =>
                  item.unitJson &&
                  UnitMapper(item, JSON.parse(item.unitJson).unit)
              ),
              totalCount: (res && res.totalCount) || 0,
            });
          }
        } else {
          setDetailsUnitsList({
            result: [],
            totalCount: 0,
          });
        }
        setIsLoadingAllUnits(false);
      }
      setIsMapChanged(false);
    },
    [
      dateFilter,
      filter,
      filterSearchDto,
      orderBy,
      pathName,
      unitStatus,
      unitsPortal,
      unitPublishStatus,
      unitsTableFilter,
      unitsPropertyName,
      unitsUnitType,
      unitsSaleType,
      unitsCommunity,
      map,
      isMapChanged,
      unitsCardsByProperty,
      selectedPropertyForMap,
      MPIFilterValue,
    ]
  );

  const getCommaSeparatedIds = (IdsArray) => {
    let IdsString = IdsArray.reduce(
      (result, item) => result + item.id + ',',
      ''
    );
    return IdsString.slice(0, IdsString.length - 1);
  };

  const getLookupItem = useCallback(async () => {
    setIsAllFormFieldsLoading(true);
    const res = await GetLookupItems(1, 25, 'PortalName');
    if (!(res && res.data && res.data.ErrorId)) {
      setPortalData(res && res.result);
    } else setPortalData([]);
  }, []);

  useEffect(() => {
    getLookupItem();
  }, []);

  const searchClicked = async () => {
    if (searchData.length === 0) return;
    localStorage.setItem('UnitsLeaseFilter', JSON.stringify(searchData));
    setFilterSearchDto(
      searchData.reduce((total, item) => {
        if (total[item.key]) {
          total[item.key].push({
            searchType: TableFilterTypesEnum.textInput.defaultSelectedOperator,
            value: item.value,
          });
        } else {
          total[item.key] = [
            {
              searchType:
                TableFilterTypesEnum.textInput.defaultSelectedOperator,
              value: item.value,
            },
          ];
        }
        return total;
      }, {})
    );
    onPageIndexChanged(0);
  };

  const searchchachedClickedWithoutFilter = async (data) => {
    if (data.length === 0) return;
    const oldfilter = data.reduce((total, item) => {
      if (total[item.key]) {
        total[item.key].push({
          searchType: TableFilterTypesEnum.textInput.defaultSelectedOperator,
          value: item.value,
        });
      } else {
        total[item.key] = [
          {
            searchType: TableFilterTypesEnum.textInput.defaultSelectedOperator,
            value: item.value,
          },
        ];
      }
      return total;
    }, {});
    getUnitsData(oldfilter);
  };

  const changePublishStatus = (value) => {
    dispatch(
      GlobalOrderFilterActions.globalOrderFilterRequest({
        ...orderFilter,
        UnitLeasePublishStatusFilter: value,
      })
    );
  };

  const tableActionClicked = useCallback(
    (actionEnum, item) => {
      dispatch(ActiveItemActions.activeItemRequest(item));
      if (actionEnum === TableActions.openFile.key) {
        if (pathName === 'units-property-management') {
          GlobalHistory.push(
            `/home/units-property-management/unit-profile-edit?formType=${item.unitTypeId}&id=${item.id}&operationType=${item.operationType}`
          );
        } else if (pathName === 'units-lease') {
          GlobalHistory.push(
            `/home/units-lease/unit-profile-edit?formType=${item.unitTypeId}&id=${item.id}&operationType=${item.operationType}`
          );
        }
      } else if (actionEnum === TableActions.editText.key) {
        if (pathName === 'units-property-management') {
          GlobalHistory.push(
            `/home/units-property-management/edit?formType=${item.unitTypeId}&id=${item.id}`
          );
        } else if (pathName === 'units-lease') {
          GlobalHistory.push(
            `/home/units-lease/edit?formType=${item.unitTypeId}&id=${item.id}`
          );
        }
      } else if (actionEnum === TableActions.addActivity.key) {
        setAddActivity(true);
        setActiveItem(item);
      }
    },
    [dispatch, pathName]
  );
  const displayedLabel = (option) => `${option.title}: ${searchInputValue}`;
  const disabledOptions = (option) => option.disabledOnSelect;
  const chipsLabel = (option) => `${option.title}: ${option.value}`;
  const inputValueChanged = (event, newInputValue) => {
    setSearchInputValue(newInputValue);
  };

  const clearActionFilters = () => {
    setUnitPublishStatus(0);
    changePublishStatus(0);
    changeActiveUnitStatus([]);
  };

  const onActionButtonChanged = (activeAction) => {
    clearActionFilters();
    setActiveSelectedAction(activeAction);
    setCheckedCards([]);
    setCheckedDetailedCards([]);
    setUnitsIdUpdateArray([]);
    onPageIndexChanged(0);

    if (activeAction === ActionsButtonsEnum[17].id) {
      changePublishStatus(0);
      setUnitPublishStatus(0);
      changeActiveUnitStatus(['Draft', 'Leased', 'ReservedLeased']);
    } else if (activeAction === ActionsButtonsEnum[18].id) {
      changePublishStatus(0);
      setUnitPublishStatus(0);
      changeActiveUnitStatus(['Available', 'Leased', 'ReservedLeased']);
    } else if (activeAction === ActionsButtonsEnum[19].id) {
      changeActiveUnitStatus(['Available']);
      changePublishStatus(2);
      setUnitPublishStatus(2);
    } else if (activeAction === ActionsButtonsEnum[20].id) {
      changeActiveUnitStatus([]);
      changePublishStatus(1);
      setUnitPublishStatus(1);
    } else if (activeAction === ActionsButtonsEnum[25].id) {
      changeActiveUnitStatus(['Available']);
      changePublishStatus(2);
      setUnitPublishStatus(2);
    }
  };

  const GetAllUnitsRef = useCallback(async (search) => {
    setSearchedItemUnitReferenceNumber(true);
    const res = await GetUnitsRefNumbers({
      unitRefNo: search,
      pageIndex: 1,
      pageSize: 10,
      operationType: StaticLookupsIds.Rent,
    });
    if (!(res && res.status && res.status !== 200))
      setData({ id: 'unitRef', value: res.result || [] });
    else setData({ id: 'unitRef', value: [] });
    setSearchedItemUnitReferenceNumber(false);
  }, []);

  const SearchHandlerComponent = useCallback(
    (key, title, data, delay) => {
      const newValue = [{ key, title, value: data }];
      if (searchTimer.current) clearTimeout(searchTimer.current);

      if (data === '') {
        const index = searchData.findIndex((item) => item.key === key);
        if (index !== -1) searchData.splice(index, 1);
        setFilterSearchDto(null);
        localStorage.removeItem('UnitsLeaseFilter');
      } else {
        searchTimer.current = setTimeout(() => {
          setSearchData([...newValue]);
          setFilterSearchDto({ [key]: [{ value: data }] });
        }, delay);
      }
    },
    [searchData]
  );

  const getActiveUserRoles = async () => {
    setIsLoading(true);
    const response = await GetAllRolesByUserId(loginResponse.userId, 1, 30);
    if (!(response && response.status && response.status !== 200)) {
      setSavedRoles(response);
    }
    setIsLoading(false);
  };

  const isNeedApprovalMessageInMarketing = async (isPublishAction) => {
    const body = {
      userBranchId: loginResponse?.branchId,
      isPublishAction,
      roleIds: savedRoles?.result?.map((item) => item.rolesId),
      userId: loginResponse?.userId,
    };
    try {
      const response = await IsNeedApprovalMessageInMarketing(body);

      if (!(response && response.status && response.status !== 200)) {
        return response;
      }
      return false;
    } catch (error) {
      console.error('API call failed:', error);
      return false;
    }
  };

  const getFieldsNeedingApproval = async () => {
    const userRoleIds = loginResponse?.roles.map((item) => item?.rolesId);

    const res = await GetFieldsNeedingApprovalForChange({ userRoleIds });
    if (!(res && res.status && res.status !== 200)) {
      setFieldsNeedsApproval(res);
    } else setFieldsNeedsApproval([]);
  };
  const handleRemoveFavorite = async (Unit) => {
    const type = 'Unit';
    const ids = Unit && Unit.id;
    const index = searchData.findIndex(
      (item) => item.key === 'FavoriteFolderId'
    );
    const folderId = index !== -1 ? searchData[index].value : folderIdValue;
    const favoriteFolderId = Unit?.favoriteFolderId;

    const result = await RemoveLeadsOrUnitsFromFolder(
      type,
      [ids],
      favoriteFolderId
    );
    if (!(result && result.status && result.status !== 200)) {
      showSuccess(t('Shared:item-remove-from-folder'));
      reloadData();
    } else {
      console.error(`Failed to remove ${type.toLowerCase()}s`);
    }
  };

  const onActionsButtonClicked = useCallback(
    async (activeAction) => {
      let callback;
      if (activeAction === ActionsButtonsEnum[3].id) {
        setIsOpenImportDialog(true);
      }
      if (activeAction === ActionsButtonsEnum[1].id) {
        if (pathName === 'units-property-management') {
          callback = () =>
            GlobalHistory.push(
              '/home/units-property-management/add?formType=1'
            );
        } else if (pathName === 'units-lease') {
          callback = () =>
            GlobalHistory.push('/home/units-lease/add?formType=1');
        }
        toggleUnitValidationDialog(callback);
        setIsFromProperty((item) => ({
          ...item,
          propertyName: false,
          operationType: false,
        }));
      }
      if (activeAction === ActionsButtonsEnum[4].id) {
        GlobalHistory.push('/home/units-lease/unit-bulk-update');
      } else if (activeAction === ActionsButtonsEnum[17].id) {
        setViewType('mark-as-available');
        setUnitsBulkStatusUpdateIsOpen(true);
      } else if (activeAction === ActionsButtonsEnum[18].id) {
        setViewType('move-to-draft');
        setUnitsBulkStatusUpdateIsOpen(true);
      } else if (activeAction === ActionsButtonsEnum[19].id) {
        setViewType('publish-to-website');
        setIsPublishedUnits(true);
        setUnitsBulkStatusUpdateIsOpen(true);
      } else if (activeAction === ActionsButtonsEnum[20].id) {
        setViewType('unpublish');
        setIsPublishedUnits(false);
        setUnitsBulkStatusUpdateIsOpen(true);
      } else if (activeAction === ActionsButtonsEnum[25].id) {
        setViewType('share-Unit');
        setUnitsBulkStatusUpdateIsOpen(true);
      } else if (activeAction === ActionsButtonsEnum[26].id) {
        setViewType('add-to-favourite');
        setisOpenFavouritDialog(true);
      }
    },
    [pathName, savedRoles]
  );

  const getAllSystemTemplateByCategoryId = useCallback(async () => {
    const res = await GetAllSystemTemplateByCategoryId(8);
    if (!(res && res.status && res.status !== 200)) {
      const mappedTemplatesData = res?.map((item) => ({
        systemTemplateName: item.systemTemplateName,
        systemTemplateId: item.systemTemplateId,
      }));
      setTemplatesProposal(mappedTemplatesData || []);
    }
  }, [filter]);

  const detailedCardSideActionClicked = useCallback(
    (actionEnum, activeData) => async (event) => {
      setHash(activeData.id);
      dispatch(ActiveItemActions.activeItemRequest(activeData));
      event.stopPropagation();
      if (actionEnum === ActionsEnum.reportEdit.key) {
        if (pathName === 'units-property-management') {
          GlobalHistory.push(
            `/home/units-property-management/edit?formType=${activeData.unitTypeId}&id=${activeData.id}`
          );
        } else if (pathName === 'units-lease') {
          GlobalHistory.push(
            `/home/units-lease/edit?formType=${activeData.unitTypeId}&id=${activeData.id}`
          );
        }
      } else if (actionEnum === ActionsEnum.folder.key) {
        if (pathName === 'units-property-management') {
          GlobalHistory.push(
            `/home/units-property-management/unit-profile-edit?formType=${activeData.unitTypeId}&id=${activeData.id}&operationType=${activeData.operationType}`
          );
        } else if (pathName === 'units-lease') {
          GlobalHistory.push(
            `/home/units-lease/unit-profile-edit?formType=${activeData.unitTypeId}&id=${activeData.id}&operationType=${activeData.operationType}`
          );
        }
      } else if (actionEnum === ActionsEnum.matching.key) {
        if (pathName === 'units-property-management') {
          GlobalHistory.push(
            `/home/units-property-management/unit-profile-edit?formType=${
              activeData.unitTypeId
            }&id=${activeData.id}&operationType=${
              activeData.operationType
            }&matching=${true}`
          );
        } else if (pathName === 'units-lease') {
          GlobalHistory.push(
            `/home/units-lease/unit-profile-edit?formType=${
              activeData.unitTypeId
            }&id=${activeData.id}&operationType=${
              activeData.operationType
            }&matching=${true}`
          );
        }
      }
    },
    [dispatch, pathName]
  );
  const filterByChanged = (value) => {
    setSelectedOrderBy((item) => ({ ...item, filterBy: value }));
  };
  const orderByChanged = (value) => {
    setSelectedOrderBy((item) => ({ ...item, orderBy: value }));
  };
  const orderBySubmitted = (event) => {
    event.preventDefault();
    if (!selectedOrderBy.filterBy || !selectedOrderBy.orderBy) {
      if (orderBy.filterBy || orderBy.orderBy) setOrderBy({});
      return;
    }
    dispatch(
      GlobalOrderFilterActions.globalOrderFilterRequest({
        ...orderFilter,
        unitsLeaseFilter: {
          filterBy: selectedOrderBy.filterBy,
          orderBy: selectedOrderBy.orderBy,
        },
      })
    );
    setOrderBy({
      filterBy: selectedOrderBy.filterBy,
      orderBy: selectedOrderBy.orderBy,
    });
  };

  useEffect(() => {
    dispatch(
      GlobalOrderFilterActions.globalOrderFilterRequest({
        ...orderFilter,
        UnitsleaseDate: dateFilter || dateRangeDefault,
      })
    );
  }, [dateFilter]);

  const cardCheckboxClicked = useCallback((itemIndex, element) => {
    setCheckedDetailedCards((items) => {
      const index = items.findIndex((item) => item === element.id);
      if (index !== -1) items.splice(index, 1);
      else items.push(element.id);
      return [...items];
    });
    setCheckedCards((items) => {
      const index = items.findIndex((item) => item.id === element.id);
      if (index !== -1) items.splice(index, 1);
      else items.push(element);
      return [...items];
    });
    setUnitsIdUpdateArray((items) => {
      if (items.includes(element.id)) {
        return items.filter((item) => item !== element.id);
      } else {
        return [...items, element.id];
      }
    });
  }, []);

  const onSelectClicked = useCallback(
    (row, rowIndex) => {
      setCheckedDetailedCards((items) => {
        const index = items.findIndex((item) => item === rowIndex);
        if (index !== -1) items.splice(index, 1);
        else items.push(rowIndex);
        return [...items];
      });

      setUnitsIdUpdateArray((items) => {
        if (items.includes(row.id)) {
          return items.filter((item) => item !== row.id);
        } else {
          return [...items, row.id];
        }
      });

      setCheckedCards((items) => {
        const index = items.findIndex((item) => item.id === row.id);
        if (index !== -1) items.splice(index, 1);
        else items.push(row);
        return [...items];
      });
    },
    [checkedCards]
  );

  useEffect(() => {
    localStorage.setItem('bulk-assign-ids', JSON.stringify(checkedCards));
    localStorage.setItem('units-ids-Array', JSON.stringify(unitsIdUpdateArray));
  }, [checkedCards]);

  const reloadData = useCallback(() => {
    setFilter((item) => ({ ...item, pageIndex: 0 }));
    setActiveCard(null);
    sideMenuComponentUpdate(null);
    sideMenuIsOpenUpdate(false);
    setCheckedDetailedCards([]);
  }, [getUnitsData]);
  const changePropretyName = (value) => {
    setSelected({ id: 'propertyName', value: value });
    const newCriteria = value?.property?.property_name || null;
    setUnitsPropertyName(newCriteria);
  };
  const changeUnitType = (value) => {
    setSelected({ id: 'unitType', value: value });
    const newCriteria = value?.lookupItemName || null;
    setUnitsUnitType(newCriteria);
  };

  const changeCommunity = (value) => {
    setSelected({ id: 'community', value: value });
    const newCriteria = value?.lookupItemName || null;
    setUnitsCommunity(newCriteria);
  };
  const getUnitDetails = useCallback(async (unitId) => {
    try {
      const res = await GetUnitDetails(unitId);
      if (res && res.leaseLeadOwner)
        localStorage.setItem('leadId', res?.leaseLeadOwner?.leadId);
      else localStorage.removeItem('leadId');

      setLeadOwnerDetails(res.leaseLeadOwner);
      return res.leaseLeadOwner;
    } catch (error) {
      setLeadOwnerDetails(null);
      localStorage.removeItem('leadId');
    }
  }, []);

  const onUnitsBulkCloseDialogHandler = () => {
    setUnitsBulkStatusUpdateIsOpen(false);
  };

  const onOpenDialogHandler = async (
    titleText,
    leadOwner,
    unitId,
    contactId
  ) => {
    setOwnerDetailsDialog({
      ...ownerDetailsDialog,
      isOpen: true,
      titleText,
    });
    await CheckContactCommunicationAndUpdate(leadOwner, unitId, contactId);
  };

  const handleCardClickBase = useCallback(
    async (item, selectedIndex, onDetailsLoaded) => {
      dispatch(ActiveItemActions.activeItemRequest(null));
      dispatch(ActiveItemActions.activeItemRequest(item));

      if (getSideMenuStatus()) setAdvanceSearchBtn(true);

      const activeData = detailsUnitsList.result[selectedIndex];
      const selectedLeadOwnerDetails = await getUnitDetails(item.id);
      setActiveCard(item);

      const ownerMobileNumber = {
        iconClasses: 'mdi mdi-point-of-sale',
        title: 'owner-mobile-number',
        value: selectedLeadOwnerDetails?.phone || 'N/A',
      };

      const details = [
        ...activeData.details.slice(0, 1),
        ownerMobileNumber,
        ...activeData.details.slice(1),
      ];

      const updatedActiveData = { ...activeData, details };

      if (onDetailsLoaded) {
        onDetailsLoaded(updatedActiveData);
      }
    },
    [detailsUnitsList.result, getSideMenuStatus, setAdvanceSearchBtn, dispatch]
  );

  const onCardClick = useCallback(
    (item, selectedIndex) => async (event) => {
      event.stopPropagation();
      event.preventDefault();

      handleCardClickBase(item, selectedIndex, (updatedActiveData) => {
        sideMenuComponentUpdate(
          <CardDetailsComponent
            activeData={updatedActiveData}
            cardDetailsActionClicked={detailedCardSideActionClicked}
            parentTranslationPath={parentTranslationPath}
            translationPath={translationPath}
            reloadData={reloadData}
            getUnitsData={getUnitsData}
            displyOpenFileButton={displyOpenFileButton}
            displyEditButton={displyEditButton}
            displyMatchingButton={displyMatchingButton}
            onClickActiveData={() => {
              dispatch(ActiveItemActions.activeItemRequest(updatedActiveData));
              onOpenDialogHandler(
                'Landlord Information',
                leadOwnerDetails,
                updatedActiveData?.id,
                updatedActiveData?.lease_lead_owner?.id
              );
            }}
          />
        );
        sideMenuIsOpenUpdate(true);
      });
    },
    [
      handleCardClickBase,
      detailedCardSideActionClicked,
      reloadData,
      getUnitsData,
      displyOpenFileButton,
      displyEditButton,
      displyMatchingButton,
      onOpenDialogHandler,
      sideMenuComponentUpdate,
      sideMenuIsOpenUpdate,
      parentTranslationPath,
      translationPath,
      leadOwnerDetails,
    ]
  );

  const onCardClickWithoutCustomSideMenu = useCallback(
    (item, selectedIndex) => async (event) => {
      event.stopPropagation();
      event.preventDefault();

      handleCardClickBase(item, selectedIndex, () => {});
    },
    [handleCardClickBase]
  );

  const focusedRowChanged = useCallback(
    async (rowIndex, item) => {
      if (rowIndex !== -1) {
        const activeData = detailsUnitsList.result[rowIndex];
        dispatch(ActiveItemActions.activeItemRequest(item));
        const newUnitDetails = item?.id ? await getUnitDetails(item.id) : null;
        sideMenuComponentUpdate(
          <CardDetailsComponent
            activeData={detailsUnitsList.result[rowIndex]}
            cardDetailsActionClicked={detailedCardSideActionClicked}
            parentTranslationPath={parentTranslationPath}
            translationPath={translationPath}
            reloadData={reloadData}
            displyOpenFileButton={displyOpenFileButton}
            displyEditButton={displyEditButton}
            displyMatchingButton={displyMatchingButton}
            onClickActiveData={() => {
              onOpenDialogHandler(
                'Landlord Information',
                leadOwnerDetails,
                activeData.id,
                activeData?.lease_lead_owner?.id
              );
            }}
          />
        );
        sideMenuIsOpenUpdate(true);
      } else {
        sideMenuComponentUpdate(<></>);
        sideMenuIsOpenUpdate(false);
      }
    },
    [
      detailedCardSideActionClicked,
      detailsUnitsList.result,
      reloadData,
      leadOwnerDetails,
      onOpenDialogHandler,
    ]
  );

  const onFilterValuesChanged = (newValue) => {
    setUnitsTableFilter(newValue);
  };

  const CheckContactCommunicationAndUpdate = async (
    leadOwner,
    unitId,
    contactId
  ) => {
    setIsLoadingLeadOwner(true);
    if (unitId) {
      const res = await GetUnitDetails(unitId);
      if (res && res.leaseLeadOwner) {
        setLeadOwnerDetails(res.leaseLeadOwner);
        if (res && res.leaseLeadOwner)
          localStorage.setItem('leadId', res?.leaseLeadOwner?.leadId);
        else localStorage.removeItem('leadId');
      } else {
        setLeadOwnerDetails(null);
      }
    }
    setIsLoadingLeadOwner(false);
  };

  useEffect(() => {
    getAllSearchableFormFieldsByFormId();
  }, [getAllSearchableFormFieldsByFormId]);

  useEffect(() => {
    const isViewAllData =
      pathName === 'units-property-management'
        ? returnPropsByPermissions(
            UnitPermissions.ViewAndSearchInPropertyManagementUnits.permissionsId
          )
        : returnPropsByPermissions(
            UnitsLeasePermissions.ViewAndSearchInLeaseUnits.permissionsId
          );
    if (isViewAllData && activeActionType !== ViewTypesEnum.map.key) {
      const currentPageIndex = localStorage.getItem(
        'unitsLeaseCurrentPageIndex'
      );
      const pageIndex = JSON.parse(currentPageIndex);
      bottomBoxComponentUpdate(
        <PaginationComponent
          pageIndex={pageIndex || filter.pageIndex}
          pageSize={filter.pageSize}
          totalCount={detailsUnitsList.totalCount}
          onPageIndexChanged={onPageIndexChanged}
          onPageSizeChanged={onPageSizeChanged}
        />
      );
    }
  });

  useEffect(
    () => () => {
      bottomBoxComponentUpdate(null);
      sideMenuComponentUpdate(null);
      sideMenuIsOpenUpdate(false);
    },
    []
  );

  const getIsSelected = useCallback(
    (row) =>
      checkedCards &&
      checkedCards.findIndex((item) => item.id === row.id) !== -1,
    [checkedCards]
  );

  const getAllFormFieldsByFormId = useCallback(async () => {
    setIsAllFormFieldsLoading(true);
    const result = await GetAllFormFieldsByFormId(FormsIdsEnum.units.id);
    if (
      !((result && result.data && result.data.ErrorId) || !result) &&
      Array.isArray(result)
    ) {
      const list = result
        .filter(
          (e) =>
            e.formFieldId !== ListingAgentIdsEnum.ListingAgent.formFieldId &&
            e.formFieldName !== 'amenities' &&
            e.formFieldName !== 'fitting_and_fixtures' &&
            e.formFieldName !== 'unit_model' &&
            e.formFieldName !== 'rent_price_fees' &&
            e.formFieldName !== 'selling_price_agency_fee' &&
            e.formFieldName !== 'primary_view' &&
            e.formFieldName !== 'secondary_view' &&
            e.formFieldName !== 'owner'
        )
        .map((field) => ({
          id: field.formFieldId || null,
          key: field.formFieldKey || null,
          isDate: field.uiWidgetType === 'alt-date' || false,
          label:
            (field.formFieldTitle === 'Lead Owner'
              ? (field.formFieldTitle = 'Unit Owner')
              : field.formFieldTitle &&
                field.formFieldTitle.replace('*', '')) || '',
          input: field.displayPath || '',
          isNumber:
            (field.propertyJson &&
              JSON.parse(field.propertyJson).schema &&
              field.propertyJson &&
              JSON.parse(field.propertyJson).schema.specialKey ===
                'currency') ||
            (field.propertyJson &&
              JSON.parse(field.propertyJson).schema &&
              field.propertyJson &&
              JSON.parse(field.propertyJson).schema.specialKey === 'decimal') ||
            (field.propertyJson &&
              JSON.parse(field.propertyJson).schema &&
              field.propertyJson &&
              JSON.parse(field.propertyJson).schema.specialKey === 'size'),
          isSortable: true,
          searchableKey: field.searchableKey,
          data: JSON.parse(field.propertyJson).schema,
          fieldType:
            (field.propertyJson &&
              JSON.parse(field.propertyJson).schema.uiType) ||
            (field.propertyJson &&
              JSON.parse(field.propertyJson).uiSchema['ui:widget']) ||
            (field.uiWidgetType === null && 'text'),
        }));

      setAllFormFields(list);
    } else setAllFormFields([]);
    setIsAllFormFieldsLoading(false);
  }, []);

  const GetSideMenuStatus = useCallback(() => {
    const isMenuOpen = getSideMenuStatus();
    const activeComponentOpen =
      getSideMenuComponent() && getSideMenuComponent().type;

    if (!isMenuOpen) setAdvanceSearchBtn(true);
    else if (activeComponentOpen === AdvanceSearch) setAdvanceSearchBtn(false);
  });

  const searchAdvanceSearch = (newFilter) => {
    const searchObj = newFilter ? { ...newFilter } : null;
    if (!(newFilter && newFilter.length))
      localStorage.removeItem('UnitsLeaseFilter');

    dispatch(
      GlobalAdvanceSearchActions.globalAdvanceSearchRequest({
        ...advanceSearch,
        UnitsLeaseFilter: searchObj || null,
      })
    );
    setUnitsTableFilter(searchObj);
  };

  const onAdvanceSearchClick = useCallback(
    (event) => {
      event.stopPropagation();
      event.preventDefault();

      if (advanceSearchBtn) {
        sideMenuIsOpenUpdate(true);
        setAdvanceSearchBtn(false);
      } else {
        sideMenuIsOpenUpdate(false);
        setAdvanceSearchBtn(true);
      }

      sideMenuComponentUpdate(
        <AdvanceSearchSecondVersion
          parentTranslationPath={parentTranslationPath}
          translationPath={translationPath}
          onFilterValuesChanged={onFilterValuesChanged}
          localStorageKey='UnitsLeaseFilter'
          isAdvanceSearchCleared={isAdvanceSearchCleared}
          setIsAdvanceSearchCleared={setIsAdvanceSearchCleared}
          setOrderBy={setOrderBy}
          searchCriteriaTypeId={SearchCriteriaEnum.Unit.typeId}
          setIsAdvanceSearchActive={setIsAdvanceSearchActive}
          fields={[
            ...UnitsLeaseTableHeaderData.filter(
              (x) => x && !x.hideOnAdvanceSearch
            ),
            ...allFormFields,
          ]}
          selectFieldsOnAdvanceSearch={selectFieldsOnAdvanceSearch}
          setSelectFieldsOnAdvanceSearch={setSelectFieldsOnAdvanceSearch}
          setFilterValuesFromAdvanceSearch={setFilterValuesFromAdvanceSearch}
          filterValuesFromAdvanceSearch={filterValuesFromAdvanceSearch}
          searchAdvanceSearch={searchAdvanceSearch}
          unitType={'rent'}
        />
      );
    },
    [
      isAllFormFieldsLoading,
      allFormFields,
      advanceSearchBtn,
      isAdvanceSearchCleared,
      selectFieldsOnAdvanceSearch,
      filterValuesFromAdvanceSearch,
    ]
  );

  const onClearedAllFiltersClick = () => {
    sideMenuIsOpenUpdate(false);
    setSelectedOrderBy((item) => ({ ...item, filterBy: null, orderBy: null }));
    setOrderBy({ filterBy: 'createdOn', orderBy: 2 });
    setSearchData([]);
    setDateFilter(dateRangeDefault);
    setMPIFilterValue(null);
    setUnitPublishStatus(0);
    setUnitStatus([]);
    setUnitsPortal([0]);
    changePropretyName(null);
    changeUnitType(null);
    changeCommunity(null);
    setIsClearFiltersClicked(true);
    setIsAdvanceSearchCleared(true);
    setUnitsTableFilter(null);
    setFilterSearchDto(null);
    setIsAdvanceSearchActive(false);
    setSelectFieldsOnAdvanceSearch([]);
    setFilterValuesFromAdvanceSearch(null);
    setMapKey(generateUniqueKey());
    setSelectedPropertyForMap(null);
    setActionButtonsKey(generateUniqueKey());
    onActionButtonChanged(ActionsButtonsEnum[1].id);

    if (isSmartProposalActive) {
      setIsSmartProposalActive(false);
      setActiveCard(null);
      setCheckedDetailedCards([]);
      setCheckedCards([]);
    }
    setSelected({
      id: 'edit',
      value: {
        propertyName: null,
        community: null,
        unitType: null,
        saleType: null,
        unitRefNo: null,
      },
    });
    dispatch(
      GlobalOrderFilterActions.globalOrderFilterRequest({
        ...orderFilter,
        UnitLeasePublishStatusFilter: 0,
        UnitsLeaseStatus: [],
        PublishLeasePortal: [],
        unitsLeaseFilter: {
          filterBy: null,
          orderBy: null,
        },
      })
    );

    dispatch(
      GlobalAdvanceSearchActions.globalAdvanceSearchRequest({
        ...advanceSearch,
        UnitsLeaseFilter: null,
      })
    );
  };

  useEffect(() => {
    getAllFormFieldsByFormId();
  }, [getAllFormFieldsByFormId]);

  const changeActiveUnitStatus = (value) => {
    if (value?.length > 1) {
      value = value.filter((item) => !!item);
    } else if (value?.length === 0) {
      value = [0];
    }
    setUnitStatus(value);
    dispatch(
      GlobalOrderFilterActions.globalOrderFilterRequest({
        ...orderFilter,
        UnitsLeaseStatus: value,
      })
    );
  };

  const checkIfHasLeaseAgentRole = () =>
    loginResponse.roles.findIndex(
      (role) => role.rolesName === 'Lease Agent'
    ) !== -1;

  const changePublishPortal = (value) => {
    if (value[0] === 0) value.shift();
    setUnitsPortal(value);
    dispatch(
      GlobalOrderFilterActions.globalOrderFilterRequest({
        ...orderFilter,
        PublishLeasePortal: value,
      })
    );
  };

  const checkBulkDesabled = (enums) => {
    if (
      enums === ActionsButtonsEnum[4].id ||
      enums === ActionsButtonsEnum[17].id ||
      enums === ActionsButtonsEnum[18].id ||
      enums === ActionsButtonsEnum[19].id ||
      enums === ActionsButtonsEnum[20].id ||
      enums === ActionsButtonsEnum[25].id
    )
      return !(checkedCards && checkedCards.length >= 2);

    return false;
  };
  useEffect(() => {
    const data = localStorage.getItem('UnitsLeaseFilter');

    if (data) {
      const leaseSearchFilter = JSON.parse(data);
      setSearchData(leaseSearchFilter);
      if (leaseSearchFilter && leaseSearchFilter.length)
        searchchachedClickedWithoutFilter(leaseSearchFilter);
    } else getUnitsData();
    if (pathName === 'units-property-management')
      setIsPropertyManagementView(true);
    else setIsPropertyManagementView(false);
  }, []);

  useEffect(() => {
    if (isFirst1) {
      if (searchData && searchData.length === 0) {
        localStorage.removeItem('UnitsLeaseFilter');
        setSearchedItem('');
      } else
        localStorage.setItem('UnitsLeaseFilter', JSON.stringify(searchData));
    } else setFirst1(true);
  }, [searchData]);

  useEffect(() => {
    if (!isFirst) setFirst(true);
    else {
      const data = localStorage.getItem('UnitsLeaseFilter');
      if (data) searchchachedClickedWithoutFilter(JSON.parse(data));
      else if (searchData && searchData.length === 0) getUnitsData();
    }
  }, [
    filterSearchDto,
    filter,
    unitStatus,
    unitsPortal,
    unitPublishStatus,
    orderBy,
    unitsTableFilter,
    pathName,
    searchData,
    map,
    selectedPropertyForMap,
    unitsPropertyName,
    unitsUnitType,
    unitsSaleType,
    unitsCommunity,
    MPIFilterValue,
  ]);

  useEffect(() => {
    if (isFirst && isDatePickerChanged) {
      const searchDataFilter = searchData.reduce((total, item) => {
        if (total[item.key]) {
          total[item.key].push({
            searchType: TableFilterTypesEnum.textInput.defaultSelectedOperator,
            value: item.value,
          });
        } else {
          total[item.key] = [
            {
              searchType:
                TableFilterTypesEnum.textInput.defaultSelectedOperator,
              value: item.value,
            },
          ];
        }
        return total;
      }, {});
      getUnitsData(searchDataFilter);
    }
  }, [dateFilter, isDatePickerChanged, searchData]);
  useEffect(() => {
    getAllFormFieldsByFormId();
  }, [getAllFormFieldsByFormId]);

  useEffect(() => {
    GetSideMenuStatus();
  }, [GetSideMenuStatus]);

  useEffect(() => {
    const openFilePermission = !isPropertyManagementView
      ? UnitsVerticalTabsData.rent
      : UnitsVerticalTabsDataUnitsPropertyManagement;
    const editFilePermission = !isPropertyManagementView
      ? UnitsLeasePermissions.EditUnitDetails.permissionsId
      : UnitPermissions.EditUnitDetails.permissionsId;
    const matchingFilePermission = !isPropertyManagementView
      ? UnitsLeasePermissions.ViewUnitMatching.permissionsId
      : '';

    setDisplyOpenFileButton(havePermissionToViewDetails(openFilePermission));
    setDisplyEditButton(havePermissionToEditInformation(editFilePermission));
    setDisplyMatchingButton(
      havePermissionToEditInformation(matchingFilePermission)
    );
  }, [isFirst]);

  const onCloseDialogHandler = () => {
    setOwnerDetailsDialog({
      ...ownerDetailsDialog,
      isOpen: false,
      titleText: '',
    });
  };

  const onFilterChanged = useCallback(
    (activeSelectedAction) => {
      if (
        activeSelectedAction === ActionsButtonsEnum[17].id &&
        ((unitStatus.length === 3 && unitStatus.includes('Available')) ||
          unitStatus.length !== 3)
      ) {
        onActionButtonChanged(ActionsButtonsEnum[1].id);
        setActionButtonsKey(generateUniqueKey());
      } else if (
        activeSelectedAction === ActionsButtonsEnum[18].id &&
        ((unitStatus.length === 3 && unitStatus.includes('Draft')) ||
          unitStatus.length !== 3)
      ) {
        onActionButtonChanged(ActionsButtonsEnum[1].id);
        setActionButtonsKey(generateUniqueKey());
      } else if (
        activeSelectedAction === ActionsButtonsEnum[19].id &&
        ((unitStatus.length === 1 && !unitStatus.includes('Available')) ||
          unitStatus.length !== 1 ||
          +unitPublishStatus !== 2)
      ) {
        onActionButtonChanged(ActionsButtonsEnum[1].id);
        setActionButtonsKey(generateUniqueKey());
      } else if (
        activeSelectedAction === ActionsButtonsEnum[20].id &&
        +unitPublishStatus !== 1
      ) {
        onActionButtonChanged(ActionsButtonsEnum[1].id);
        setActionButtonsKey(generateUniqueKey());
      }
    },
    [activeSelectedAction, unitStatus, unitPublishStatus]
  );

  useEffect(() => {
    onFilterChanged(activeSelectedAction);
  }, [activeSelectedAction, unitStatus, unitPublishStatus]);

  useEffect(() => {
    getActiveUserRoles();
    getAllSystemTemplateByCategoryId();
    getFieldsNeedingApproval();
  }, []);

  const onPinClick =
    ({ name }) =>
    () => {
      setUnitCardsByProperty(true);
      setSelectedPropertyForMap({
        key: 'property_name',
        title: 'Property Name *',
        value: name,
      });
      sideMenuIsOpenUpdate(true);
    };
  useEffect(() => {
    if (
      unitsCardsByProperty &&
      getSideMenuStatus() &&
      isMapView &&
      advanceSearchBtn
    ) {
      sideMenuComponentUpdate(
        <UnitsByProperty
          {...detailsUnitsList}
          isLoading={isLoadingAllUnits}
          translationPath={translationPath}
          parentTranslationPath={parentTranslationPath}
          pageIndex={filter.pageIndex}
          pageSize={filter.pageSize}
          onPageIndexChange={(index) =>
            setFilter((prevFilter) => ({ ...prevFilter, pageIndex: index }))
          }
          onPageSizeChange={(size) =>
            setFilter((prevFilter) => ({ ...prevFilter, pageSize: size }))
          }
          selectedCards={selectedUnitsCards}
          onSelectCard={(item) =>
            setSelectedUnitsCards((prevSelected) => prevSelected.concat(item))
          }
          onRemoveCard={(id) =>
            setSelectedUnitsCards((prevSelected) =>
              prevSelected.filter((unit) => unit.id !== id)
            )
          }
          propertyName={selectedPropertyForMap?.value}
          isLease
          isSendProposalDisabled={selectedUnitsCards.length === 0}
          openTemplateDialog={() => setIsSelectTemplateOpen(true)}
        />
      );
    }
  }, [
    unitsCardsByProperty,
    isLoadingAllUnits,
    detailsUnitsList,
    selectedUnitsCards,
    searchData,
  ]);

  useEffect(() => {
    setUnitCardsByProperty(getSideMenuStatus());
  }, [getSideMenuStatus()]);

  useEffect(() => {
    if (activeActionType !== ViewTypesEnum.map.key) {
      setMap(null);
      setSelectedPropertyForMap(null);
    }
  }, [activeActionType]);

  return (
    <>
      <div className="view-wrapper lease-view">
        <Spinner isActive={isLoadingAllUnits && !isMapView} />
        <div className="d-flex-column">
          <div className="header-section">
            <Spinner isActive={isMapView && isLoadingAllUnits} isAbsolute />
            <div className="filter-section">
              <div className="section section-resize">
                <ActionsButtonsComponent
                  key={actionButtonsKey}
                  permissionsList={
                    !isPropertyManagementView
                      ? Object.values(UnitsLeasePermissions)
                      : Object.values(UnitPermissions)
                  }
                  addPermissionsId={
                    !isPropertyManagementView
                      ? UnitsLeasePermissions.AddNewUnit.permissionsId
                      : UnitPermissions.AddNewUnit.permissionsId
                  }
                  selectPermissionsId={
                    !isPropertyManagementView
                      ? [
                          UnitsLeasePermissions.ImportUnits.permissionsId,
                          UnitsLeasePermissions.UnitBulkUpdate.permissionsId,
                          UnitsLeasePermissions.AddNewUnit.permissionsId,
                          UnitsLeasePermissions.ShareUnits.permissionsId,
                        ]
                      : [
                          UnitPermissions.ImportUnit.permissionsId,
                          UnitPermissions.UnitBulkUpdate.permissionsId,
                          UnitPermissions.AddNewUnit.permissionsId,
                        ]
                  }
                  onActionsButtonClicked={onActionsButtonClicked}
                  onActionButtonChanged={onActionButtonChanged}
                  enableBulk={
                    !isPropertyManagementView
                      ? getIsAllowedPermission(
                          Object.values(UnitsLeasePermissions),
                          loginResponse,
                          UnitsLeasePermissions.UnitBulkUpdate.permissionsId
                        )
                      : getIsAllowedPermission(
                          Object.values(UnitPermissions),
                          loginResponse,
                          UnitPermissions.UnitBulkUpdate.permissionsId
                        )
                  }
                  enableMarkAsAvailable={returnPropsByPermissions(
                    UnitsLeasePermissions
                      .MakeTransactionOnUnitLeaseToBeAvailable.permissionsId
                  )}
                  enableMoveToDraft={returnPropsByPermissions(
                    UnitsLeasePermissions.MakeTransactionOnUnitLeaseToBeDraft
                      .permissionsId
                  )}
                  enableAddToFavourite
                  enablePublishToWebsite={returnPropsByPermissions(
                    UnitsLeasePermissions.EditPublishedToWebsiteMarketing
                      .permissionsId
                  )}
                  enableUnpublish
                  enableShareUnit={getIsAllowedPermission(
                    Object.values(UnitsLeasePermissions),
                    loginResponse,
                    UnitsLeasePermissions.ShareUnits.permissionsId
                  )}
                  checkDisable={checkBulkDesabled}
                  enableImport={
                    !isPropertyManagementView
                      ? getIsAllowedPermission(
                          Object.values(UnitsLeasePermissions),
                          loginResponse,
                          UnitsLeasePermissions.ImportUnits.permissionsId
                        )
                      : getIsAllowedPermission(
                          Object.values(UnitPermissions),
                          loginResponse,
                          UnitPermissions.ImportUnit.permissionsId
                        )
                  }
                />
                {/* {checkIfHasLeaseAgentRole() && */}
                <PermissionsComponent
                  permissionsList={Object.values(
                    LeaseTransactionJourneyPermissions
                  )}
                  permissionsId={
                    LeaseTransactionJourneyPermissions?.MakeTransaction
                      ?.permissionsId
                  }
                >
                  <ButtonBase
                    id="make-transaction-btn"
                    onClick={() => setIsTransactionStartOpen(true)}
                    className="btns theme-solid px-4 py-2"
                  >
                    {t(`${translationPath}make-transaction`)}
                  </ButtonBase>
                </PermissionsComponent>
                <ProposalStartButton
                  checkboxSelectHandler={(isActive) => {
                    setIsSmartProposalActive(isActive);
                    if (!isActive) {
                      setActiveCard(null);
                      setCheckedDetailedCards([]);
                      setCheckedCards([]);
                    }
                  }}
                  buttonType={
                    isSmartProposalActive ? "select-counter" : "select-outline"
                  }
                  isForLease
                />
              </div>
              <div className="section autocomplete-section">
                <PermissionsComponent
                  permissionsList={
                    !isPropertyManagementView
                      ? Object.values(UnitsLeasePermissions)
                      : Object.values(UnitPermissions)
                  }
                  permissionsId={
                    !isPropertyManagementView
                      ? UnitsLeasePermissions.ViewAndSearchInLeaseUnits
                          .permissionsId
                      : UnitPermissions.ViewAndSearchInPropertyManagementUnits
                          .permissionsId
                  }
                >
                  <div className="d-flex-column px-2 w-100 p-relative">
                    <div className="d-flex-column w-100">
                      <AutocompleteComponent
                        data={searchableFormFields.map((item) => ({
                          key: item.key,
                          title: item.title,
                        }))}
                        selectedValues={searchData}
                        parentTranslationPath={parentTranslationPath}
                        displayLabel={displayedLabel}
                        disabledOptions={disabledOptions}
                        onChange={filterOnChange}
                        searchClicked={searchClicked}
                        chipsLabel={chipsLabel}
                        getOptionSelected={(option) =>
                          searchData.findIndex(
                            (item) =>
                              item.key === option.key &&
                              item.value === searchInputValue
                          ) !== -1
                        }
                        tagValues={searchData}
                        inputValue={searchInputValue}
                        onInputChange={inputValueChanged}
                        inputLabel="filter"
                        inputPlaceholder="search-units"
                      />
                    </div>
                    <div className="d-inline-flex pl-5-reversed">
                      <div className="mt-2 mr-1-reversed">
                        <SelectComponet
                          data={Object.values(UnitsFilterStatusEnum.lease)}
                          emptyItem={{
                            value: 0,
                            text: "select-status",
                            isDisabled: true,
                            isHiddenOnOpen: true,
                          }}
                          value={unitStatus}
                          valueInput="value"
                          textInput="title"
                          multiple
                          onSelectChanged={changeActiveUnitStatus}
                          wrapperClasses="w-auto"
                          themeClass="theme-default"
                          idRef="Unit_Status"
                          startAdornment={
                            (unitStatus.findIndex((item) => item === 0) ===
                              -1 && (
                              <Button
                                title="Remove Filter"
                                className="mdi mdi-filter-off mr-4 c-warning"
                                onClick={() => changeActiveUnitStatus([])}
                              />
                            )) ||
                            ""
                          }
                          parentTranslationPath={parentTranslationPath}
                          translationPath={translationPath}
                          translationPathForData={translationPath}
                        />
                      </div>
                      <div className="mt-2 mr-1-reversed">
                        <SelectComponet
                          idRef="Unit_portal"
                          data={PortalData}
                          emptyItem={{
                            value: 0,
                            text: "publish-portal",
                            isDisabled: true,
                            isHiddenOnOpen: true,
                          }}
                          value={unitsPortal}
                          valueInput="lookupItemId"
                          textInput="lookupItemName"
                          multiple
                          onSelectChanged={changePublishPortal}
                          wrapperClasses="w-auto"
                          themeClass="theme-default"
                          startAdornment={
                            (unitsPortal.findIndex((item) => item === 0) ===
                              -1 && (
                              <Button
                                title="Remove Filter"
                                className="mdi mdi-filter-off mr-4 c-warning"
                                onClick={() => changePublishPortal([0])}
                              />
                            )) ||
                            ""
                          }
                          parentTranslationPath={parentTranslationPath}
                          translationPath={translationPath}
                          translationPathForData={translationPath}
                        />
                      </div>
                      <div className="mt-2 mr-1-reversed">
                        <SelectComponet
                          data={[
                            { key: 1, name: "published" },
                            { key: 2, name: "unpublished" },
                          ]}
                          emptyItem={{
                            value: 0,
                            text: "select-unit-publish",
                            isDisabled: false,
                          }}
                          value={unitPublishStatus || 0}
                          valueInput="key"
                          textInput="name"
                          onSelectChanged={(value) => {
                            changePublishStatus(value);
                            setUnitPublishStatus(value);
                          }}
                          wrapperClasses="w-auto"
                          themeClass="theme-default"
                          idRef="Select_Unit_Publish"
                          parentTranslationPath={parentTranslationPath}
                          translationPath={translationPath}
                          translationPathForData={translationPath}
                        />
                      </div>
                      <div className="w-100 mt-2  ">
                        <Inputs
                          value={searchedItem}
                          onKeyUp={(e) => searchHandler(e.target.value)}
                          idRef="activitiesSearchRef"
                          labelClasses="mt-4"
                          onInputChanged={(e) =>
                            setSearchedItem(e.target.value)
                          }
                          inputPlaceholder={t(
                            `${translationPath}address-filter`
                          )}
                        />
                      </div>
                      <div className="w-100 customDatePicker">
                        <div className="date-type-select">
                          <SelectComponet
                            data={[
                              {
                                key: 1,
                                value: `${translationPath}created-date`,
                              },
                              {
                                key: 2,
                                value: `${translationPath}update-on-date`,
                              },
                              {
                                key: 4,
                                value: `${translationPath}listing-date`,
                              },
                              {
                                key: 5,
                                value: `${translationPath}publish-date`,
                              },
                              {
                                key: 6,
                                value: `${translationPath}expired-listing-date`,
                              },
                            ]}
                            defaultValue={{
                              key: 1,
                              value: `${translationPath}created-date`,
                            }}
                            value={dateFilter.selectedDateType || 1}
                            valueInput="key"
                            textInput="value"
                            isDisabled={isLoading}
                            onSelectChanged={(value) => {
                              setIsDatePickerChanged(true);
                              setDateFilter((f) => ({
                                ...f,
                                selectedDateType: value,
                              }));
                            }}
                            wrapperClasses="w-auto"
                            themeClass="theme-transparent"
                            idRef="Date_Select"
                            parentTranslationPath={parentTranslationPath}
                            translationPath={translationPath}
                            translationPathForData={translationPath}
                          />
                        </div>
                        <DateRangePickerComponent
                          onClearClicked={() => {
                            setDateFilter(dateRangeDefault);
                            setIsDatePickerChanged(true);
                          }}
                          onDialogClose={() => {
                            setIsDatePickerChanged(true);
                          }}
                          ranges={[dateFilter]}
                          parentTranslationPath={parentTranslationPath}
                          translationPath={translationPath}
                          onDateChanged={(selectedDate) =>
                            setDateFilter((item) => ({
                              ...item,
                              startDate:
                                selectedDate.selection &&
                                selectedDate.selection.startDate,
                              endDate: new Date(
                                moment(
                                  selectedDate.selection &&
                                    selectedDate.selection.endDate
                                ).endOf("day")
                              ),
                              key: "selection",
                            }))
                          }
                          isDisabled={isLoading}
                        />
                      </div>
                    </div>
                    <div className="d-flex pl-5-reversed w-100">
                      <div className="mt-2 mr-1-reversed w-50">
                        <AutocompleteComponent
                          inputPlaceholder="property-name"
                          data={data.propertyName}
                          parentTranslationPath={parentTranslationPath}
                          translationPath={translationPath}
                          withoutSearchButton
                          selectedValues={selected.propertyName}
                          onOpen={() => {
                            if (
                              data.propertyName &&
                              data.propertyName.length === 0
                            )
                              getAllProperties();
                          }}
                          onInputKeyUp={(event) => {
                            const { value } = event.target;
                            if (searchTimer.current)
                              clearTimeout(searchTimer.current);
                            searchTimer.current = setTimeout(() => {
                              getAllProperties(value);
                            }, 700);
                          }}
                          displayLabel={(option) =>
                            option.property.property_name || ""
                          }
                          onChange={(_, newValue) => {
                            changePropretyName(newValue);
                          }}
                          chipsLabel={(option) =>
                            option.property.property_name || ""
                          }
                          multiple={false}
                        />
                      </div>

                      <div className="mt-2 mr-1-reversed w-50">
                        <AutocompleteComponent
                          inputPlaceholder="community"
                          data={data.community}
                          parentTranslationPath={parentTranslationPath}
                          translationPath={translationPath}
                          withoutSearchButton
                          selectedValues={selected.community}
                          onOpen={() => {
                            if (data.community && data.community.length === 0)
                              getCommunityType();
                          }}
                          chipsLabel={(option) => option.lookupItemName || ""}
                          multiple={false}
                          onChange={(_, newValue) => {
                            changeCommunity(newValue);
                          }}
                          onInputKeyUp={(event) => {
                            const { value } = event.target;
                            if (searchTimer.current)
                              clearTimeout(searchTimer.current);
                            searchTimer.current = setTimeout(() => {
                              getCommunityType();
                            }, 700);
                          }}
                          displayLabel={(option) => option.lookupItemName || ""}
                        />
                      </div>
                      <div className="mt-2 mr-1-reversed w-50">
                        <AutocompleteComponent
                          inputPlaceholder="unit-type"
                          data={data.unitType}
                          parentTranslationPath={parentTranslationPath}
                          translationPath={translationPath}
                          withoutSearchButton
                          selectedValues={selected.unitType}
                          onOpen={() => {
                            if (data.unitType && data.unitType.length === 0)
                              getLookupItemsByLookupTypeName("unitType");
                          }}
                          displayLabel={(option) => option.lookupItemName || ""}
                          onInputKeyUp={(event) => {
                            const { value } = event.target;
                            if (searchTimer.current)
                              clearTimeout(searchTimer.current);
                            searchTimer.current = setTimeout(() => {
                              getLookupItemsByLookupTypeName(value);
                            }, 700);
                          }}
                          chipsLabel={(option) => option.lookupItemName || ""}
                          multiple={false}
                          onChange={(_, newValue) => {
                            changeUnitType(newValue);
                          }}
                        />
                      </div>
                      <div className="mt-2 mr-1-reversed w-50">
                        <AutocompleteComponent
                          inputPlaceholder={t(
                            `${translationPath}Unit-Reference-Number`
                          )}
                          data={data.unitRef}
                          parentTranslationPath={parentTranslationPath}
                          translationPath={translationPath}
                          withoutSearchButton
                          isLoading={SearchedItemUnitReferenceNumber}
                          displayLabel={(option) => option?.unitRefNo || ""}
                          onInputKeyUp={(event) => {
                            const { value } = event.target;
                            if (searchTimer.current)
                              clearTimeout(searchTimer.current);
                            searchTimer.current = setTimeout(() => {
                              GetAllUnitsRef(value);
                            }, 700);
                          }}
                          chipsLabel={(option) => option?.unitRefNo || ""}
                          multiple={false}
                          onChange={(_, newValue) => {
                            if (newValue) {
                              SearchHandlerComponent(
                                "unit_ref_no",
                                "Unit Ref No.",
                                (newValue && newValue.unitRefNo) || "",
                                1300
                              );
                              setSelected({ id: "unitRefNo", value: newValue });
                            } else {
                              const index = searchData.findIndex(
                                (item) => item.key === "unit_ref_no"
                              );
                              if (index !== -1) searchData.splice(index, 1);
                              setFilterSearchDto(null);
                              localStorage.removeItem("UnitsLeaseFilter");
                              getUnitsData();
                            }
                          }}
                          selectedValues={selected.unitRefNo}
                        />
                      </div>
                    </div>
                  </div>
                </PermissionsComponent>
                <div className="view-search-wrapper">
                  <PermissionsComponent
                    permissionsList={
                      !isPropertyManagementView
                        ? Object.values(UnitsLeasePermissions)
                        : Object.values(UnitPermissions)
                    }
                    permissionsId={
                      !isPropertyManagementView
                        ? UnitsLeasePermissions.ViewAndSearchInLeaseUnits
                            .permissionsId
                        : UnitPermissions.ViewAndSearchInPropertyManagementUnits
                            .permissionsId
                    }
                  >
                    <ViewTypes
                      onTypeChanged={onTypeChanged}
                      initialActiveType={activeActionType}
                      className="mb-3"
                      withMap
                    />
                    <span className="advance-search">
                      <ButtonBase
                        onClick={onAdvanceSearchClick}
                        id="AdvanceSearch_bbt"
                        disabled={isAllFormFieldsLoading}
                        className={`btns theme-solid ${
                          isAdvanceSearchActive &&
                          !isAllFormFieldsLoading &&
                          "is-active-filter"
                        }`}
                      >
                        <span
                          className={`${
                            advanceSearchBtn
                              ? "mdi mdi-arrow-expand-left"
                              : "mdi mdi-arrow-expand-right"
                          } mr-1`}
                        />
                        {t(`${translationPath}advance-search`)}
                      </ButtonBase>
                    </span>
                    <ButtonBase
                      onClick={onClearedAllFiltersClick}
                      id="onClearedAllFiltersref"
                      disabled={isAllFormFieldsLoading}
                      className="btns theme-solid bg-danger clear-all-btn"
                    >
                      <span className="mdi mdi-filter-remove m-1" />
                      {t(`${translationPath}clear-filters`)}
                    </ButtonBase>
                  </PermissionsComponent>
                  <PermissionsComponent
                    permissionsList={
                      !isPropertyManagementView
                        ? Object.values(UnitsLeasePermissions)
                        : Object.values(UnitPermissions)
                    }
                    permissionsId={
                      !isPropertyManagementView
                        ? UnitsLeasePermissions.UnitDuplications.permissionsId
                        : UnitPermissions.ViewAndSearchInPropertyManagementUnits
                            .permissionsId
                    }
                  >
                    <ButtonBase
                      onClick={checkDuplicatedUnitsButton}
                      id="leaseCheckDuplicatedUnitsButton"
                      disabled={isAllFormFieldsLoading}
                      className="btns theme-solid w-100 m-2"
                    >
                      {t(`${translationPath}duplicates`)}
                    </ButtonBase>
                  </PermissionsComponent>
                  <ButtonBase
                    onClick={() => {
                      setisOpenFavouritDialog(true);
                      setViewType("");
                    }}
                    id="cheitsButton"
                    className="btns theme-solid w-100 m-2"
                  >
                    <span className="mdi mdi-heart-box-outline ml-1"></span>
                    {t(`${translationPath}View-Favourite`)}
                  </ButtonBase>
                  <PermissionsComponent
                    permissionsList={
                      !isPropertyManagementView
                        ? Object.values(UnitsLeasePermissions)
                        : Object.values(UnitPermissions)
                    }
                    permissionsId={
                      !isPropertyManagementView
                        ? UnitsLeasePermissions.ArchiveUnit.permissionsId
                        : UnitPermissions.ViewAndSearchInPropertyManagementUnits
                            .permissionsId
                    }
                  >
                    <ButtonBase
                      onClick={() => {
                        setArchiveWizardDialog(true);
                      }}
                      id="ArchiveButton"
                      className="btns theme-solid w-100 "
                    >
                      <span className="mdi mdi-archive  ml-1"></span>
                      {t(`${translationPath}Archive`)}
                    </ButtonBase>
                  </PermissionsComponent>
                </div>
              </div>
            </div>
            <PermissionsComponent
              permissionsList={
                !isPropertyManagementView
                  ? Object.values(UnitsLeasePermissions)
                  : Object.values(UnitPermissions)
              }
              permissionsId={
                !isPropertyManagementView
                  ? UnitsLeasePermissions.ViewAndSearchInLeaseUnits
                      .permissionsId
                  : UnitPermissions.ViewAndSearchInPropertyManagementUnits
                      .permissionsId
              }
            >
              {selectedUnitsCards.length !== 0 && (
                <div className=" p-3">
                  <div className=" d-flex">
                    <Button
                      variant="contained"
                      className="btns theme-solid"
                      color="primary"
                      onClick={() => setIsSelectedUnitDialogOpen(true)}
                    >
                      <strong>
                        ({selectedUnitsCards.length}) selected units
                      </strong>
                    </Button>
                    <SelectComponet
                      data={templatesProposal}
                      keyLoopBy="systemTemplateId"
                      valueInput="systemTemplateId"
                      textInput="systemTemplateName"
                      value={activeTemplateId}
                      emptyItem={{
                        value: null,
                        text: "select-template",
                        isDisabled: false,
                      }}
                      keyValue="actionsbuttons"
                      idRef="contactsActionsRef"
                      onSelectChanged={(value) => {
                        setActiveTemplateId(value);
                        if (value) {
                          setIsProposalDialogOpen(true);
                        }
                      }}
                      themeClass="theme-action-buttons"
                      translationPath={translationPath}
                      translationPathForData={translationPath}
                      wrapperClasses="bg-secondary c-white mx-2"
                      parentTranslationPath={parentTranslationPath}
                    />
                  </div>
                </div>
              )}
              <div className="d-flex px-2">
                <span className="mx-2 mt-1">
                  {t(`${translationPath}units`)}
                </span>
                <span className="separator-v s-primary s-reverse s-h-25px mt-1" />
                <span className="px-2 d-flex">
                  <span className="texts-large mt-1">
                    {t(`${translationPath}order-by`)}:
                  </span>
                  <div className="px-2">
                    <SelectComponet
                      idRef="filterByRef"
                      data={[
                        { id: "createdOn", filterBy: "created-on" },
                        { id: "updateOn", filterBy: "last-updated" },
                        {
                          id: "LastUpdatedOwner",
                          filterBy: "last-updated-owner",
                        },
                      ]}
                      value={selectedOrderBy.filterBy}
                      onSelectChanged={filterByChanged}
                      wrapperClasses="mb-3"
                      isRequired
                      valueInput="id"
                      textInput="filterBy"
                      emptyItem={{
                        value: null,
                        text: "select-filter-by",
                        isDisabled: false,
                      }}
                      parentTranslationPath={parentTranslationPath}
                      translationPath={translationPath}
                      translationPathForData={translationPath}
                    />
                  </div>
                  <div className="px-2">
                    <SelectComponet
                      idRef="orderByRef"
                      data={[
                        { id: 1, orderBy: "ascending" },
                        { id: 2, orderBy: "descending" },
                      ]}
                      value={selectedOrderBy.orderBy}
                      onSelectChanged={orderByChanged}
                      wrapperClasses="mb-3"
                      isRequired
                      valueInput="id"
                      textInput="orderBy"
                      emptyItem={{
                        value: null,
                        text: "select-sort-by",
                        isDisabled: false,
                      }}
                      parentTranslationPath={parentTranslationPath}
                      translationPath={translationPath}
                      translationPathForData={translationPath}
                    />
                  </div>
                  <div className="mt-1">
                    <ButtonBase
                      className="btns theme-solid"
                      id="action_apply"
                      onClick={orderBySubmitted}
                      disabled={
                        !selectedOrderBy.filterBy || !selectedOrderBy.orderBy
                      }
                    >
                      <span>{t(`${translationPath}apply`)}</span>
                    </ButtonBase>
                  </div>
                </span>
              </div>
            </PermissionsComponent>
          </div>
          {[ViewTypesEnum.cards.key, ViewTypesEnum.cardsExpanded.key].includes(
            activeActionType
          ) && (
            <>
              <div className="body-section">
                <PermissionsComponent
                  permissionsList={
                    !isPropertyManagementView
                      ? Object.values(UnitsLeasePermissions)
                      : Object.values(UnitPermissions)
                  }
                  permissionsId={
                    !isPropertyManagementView
                      ? UnitsLeasePermissions.ViewAndSearchInLeaseUnits
                          .permissionsId
                      : UnitPermissions.ViewAndSearchInPropertyManagementUnits
                          .permissionsId
                  }
                >
                  <UnitsCardsComponent
                    data={detailsUnitsList}
                    isExpanded={isExpanded}
                    folderIdValue={folderIdValue}
                    handleRemoveFavorite={handleRemoveFavorite}
                    onCardClicked={onCardClick}
                    onFooterActionsClicked={detailedCardSideActionClicked}
                    checkedDetailedCards={checkedDetailedCards}
                    parentTranslationPath={parentTranslationPath}
                    translationPath={translationPath}
                    onCardClickWithoutCustomSideMenu={
                      onCardClickWithoutCustomSideMenu
                    }
                    onCardCheckboxClick={cardCheckboxClicked}
                    setIsDialogRequestActivityOpen={
                      setIsDialogRequestActivityOpen
                    }
                    setIsDialogPriceNegotiatioOpen={
                      setIsDialogPriceNegotiatioOpen
                    }
                    activeCard={activeCard}
                    setActiveCard={setActiveCard}
                    unitsIdUpdateArray={unitsIdUpdateArray}
                    setUnitsIdUpdateArray={setUnitsIdUpdateArray}
                    withCheckbox={
                      activeSelectedAction === "bulk-update" ||
                      activeSelectedAction === "unit-status-bulk-update" ||
                      activeSelectedAction === "move-to-draft" ||
                      activeSelectedAction === "mark-as-available" ||
                      activeSelectedAction === "publish-to-website" ||
                      activeSelectedAction === "unpublish" ||
                      activeSelectedAction === "add-to-favourite" ||
                      activeSelectedAction === "share-unit" ||
                      isSmartProposalActive
                    }
                    displyOpenFileButton={displyOpenFileButton}
                    displyEditButton={displyEditButton}
                    displyMatchingButton={displyMatchingButton}
                  />
                </PermissionsComponent>
              </div>
            </>
          )}
          {activeActionType === ViewTypesEnum.map.key && (
            <UnitsMapView
              key={mapKey}
              setMap={(map) => {
                setIsMapChanged(true);
                setMap(map);
              }}
              totalCount={detailsPropertyByUnitsList.totalCount}
              totalUnitsCount={
                detailsPropertyByUnitsList.result?.[0]?.totalCountUnits
              }
              isLoading={isLoadingAllUnits}
              locations={detailsPropertyByUnitsList.result?.map(
                (property, index) => {
                  return {
                    latitude: property?.latitude,
                    longitude: property?.longitude,
                    name: property?.propertyName,
                    id: property?.propertyId,
                    propertyTypeId: property?.propertyTypeId,
                    noOfUnits: property?.noOfUnits,
                    createdOn: property?.createdOn,
                    propertyStatus: property?.property_plan,
                    index,
                  };
                }
              )}
              onPinClick={onPinClick}
              stopChangeCapturing={stopChangeCapturing}
            />
          )}
          {activeActionType === ViewTypesEnum.tableView.key && (
            <PermissionsComponent
              permissionsList={
                !isPropertyManagementView
                  ? Object.values(UnitsLeasePermissions)
                  : Object.values(UnitPermissions)
              }
              permissionsId={
                !isPropertyManagementView
                  ? UnitsLeasePermissions.ViewAndSearchInLeaseUnits
                      .permissionsId
                  : UnitPermissions.ViewAndSearchInPropertyManagementUnits
                      .permissionsId
              }
            >
              <UnitsLeaseTableComponent
                detailsUnitsList={detailsUnitsList}
                tableActionClicked={tableActionClicked}
                onPageIndexChanged={onPageIndexChanged}
                onPageSizeChanged={onPageSizeChanged}
                unitsTableFilter={unitsTableFilter}
                onFilterValuesChanged={onFilterValuesChanged}
                filter={filter}
                parentTranslationPath={parentTranslationPath}
                focusedRowChanged={focusedRowChanged}
                onSelectClicked={onSelectClicked}
                setCheckedCards={setCheckedCards}
                checkedCardsIds={checkedCards}
                getIsSelected={getIsSelected}
                activeSelectedAction={activeSelectedAction}
                setOrderBy={setOrderBy}
                isSmartProposalActive={isSmartProposalActive}
                isClearFiltersClicked={isClearFiltersClicked}
                setIsClearFiltersClicked={setIsClearFiltersClicked}
                displyOpenFileButton={displyOpenFileButton}
                displyEditButton={displyEditButton}
                displyMatchingButton={displyMatchingButton}
                unitsIdUpdateArray={unitsIdUpdateArray}
                setUnitsIdUpdateArray={setUnitsIdUpdateArray}
                localStorageKey="UnitsLeaseFilter"
              />
            </PermissionsComponent>
          )}
        </div>
        <UnitsImportDialog
          isOpen={isOpenImportDialog}
          isOpenChanged={() => setIsOpenImportDialog(false)}
        />
        {addActivity && (
          <ActivitiesManagementDialog
            open={addActivity}
            onSave={() => {
              setAddActivity(false);
            }}
            close={() => {
              setAddActivity(false);
            }}
            actionItemId={activeItem?.id}
            translationPath={""}
            parentTranslationPath={"ActivitiesView"}
            unitOperationId={activeItem?.operation_type?.lookupItemId}
            unitTypeId={activeItem?.unit_type?.lookupItemId}
          />
        )}
      </div>
      {ownerDetailsDialog.isOpen && (
        <DialogComponent
          isOpen={ownerDetailsDialog.isOpen}
          onCloseClicked={onCloseDialogHandler}
          titleText={ownerDetailsDialog.titleText}
          maxWidth="lg"
          dialogContent={
            <OwnerDetailsDialog
              data={leadOwnerDetails}
              leadOwnerDetails={leadOwnerDetails}
              translationPath={parentTranslationPath}
              operationType={"lease"}
              isLoadingLeadOwner={isLoadingLeadOwner}
            />
          }
        />
      )}

      {unitsBulkStatusUpdateIsOpen && (
        <DialogComponent
          isOpen={unitsBulkStatusUpdateIsOpen}
          titleText={t("unit-status-bulk-update")}
          maxWidth="lg"
          dialogContent={
            <>
              <UnitsBulkStatusUpdateDialog
                onUnitsBulkCloseDialogHandler={onUnitsBulkCloseDialogHandler}
                unitsIdUpdateArray={unitsIdUpdateArray}
                setUnitsIdUpdateArray={setUnitsIdUpdateArray}
                viewType={viewType}
                reloadData={reloadData}
                setViewType={setViewType}
                isPublishedUnits={isPublishedUnits}
                onClearedAllFiltersClick={onClearedAllFiltersClick}
                checkedCards={checkedCards}
                unitOperationSource={unitOperationSource.lease.key}
                isNeedApprovalMessageInMarketing={
                  isNeedApprovalMessageInMarketing
                }
                setNeedsApprovalDialog={setNeedsApprovalDialog}
                setTypeOfRequest={setTypeOfRequest}
                fieldsNeedsApproval={fieldsNeedsApproval}
                setFieldsNeedsApprovalDialog={setFieldsNeedsApprovalDialog}
              />
            </>
          }
        />
      )}

      {isTransactionStartOpen && (
        <TransactionUnitSelectionDialog
          isDialogOpen={isTransactionStartOpen}
          onClose={() => {
            setIsTransactionStartOpen(false);
          }}
        />
      )}
      {needsApprovalDialog && (
        <NeedsApprovalDialogBulkUnit
          setIsDialogOpen={setNeedsApprovalDialog}
          isDialogOpen={needsApprovalDialog}
          loginResponse={loginResponse}
          typeOfRequest={typeOfRequest}
          unitsIdUpdateArray={unitsIdUpdateArray}
          reloadData={reloadData}
          parentTranslationPath={parentTranslationPath}
          translationPath={translationPath}
          checkedCards={checkedCards}
          onUnitsBulkCloseDialogHandler={onUnitsBulkCloseDialogHandler}
        />
      )}
      {fieldsNeedsApprovalDialog && (
        <FieldsNeedsApprovalDialogBulkUnits
          parentTranslationPath={parentTranslationPath}
          translationPath={translationPath}
          setIsDialogOpen={setFieldsNeedsApprovalDialog}
          isDialogOpen={fieldsNeedsApprovalDialog}
          checkedCards={checkedCards}
          reloadData={reloadData}
          onUnitsBulkCloseDialogHandler={onUnitsBulkCloseDialogHandler}
          unitsIdUpdateArray={unitsIdUpdateArray}
          isUpdatedState
        />
      )}
      {isSelectedUnitDialogOpen && (
        <DialogComponent
          isOpen
          maxWidth={"lg"}
          titleText={"selected-units"}
          onCloseClicked={() => setIsSelectedUnitDialogOpen(false)}
          dialogContent={
            <div className=" d-flex fj-center flex-wrap gap-1">
              {Children.toArray(
                selectedUnitsCards.map((item) => (
                  <UnitCard
                    item={item}
                    onRemoveCard={(id) =>
                      setSelectedUnitsCards((prev) =>
                        prev.filter((unit) => unit.id !== id)
                      )
                    }
                    selectedCards={selectedUnitsCards}
                    parentTranslationPath={parentTranslationPath}
                    translationPath={translationPath}
                    isLease
                  />
                ))
              )}
            </div>
          }
          parentTranslationPath={parentTranslationPath}
          translationPath={translationPath}
          onSaveClicked={(e) => {
            e.preventDefault();
            if (!activeTemplateId) {
              setIsSelectTemplateOpen(true);
            } else {
              setIsProposalDialogOpen(true);
            }
          }}
          saveText={"send-proposal"}
        />
      )}
      {isProposalDialogOpen && (
        <UnitTemplateDialogPreviewDialog
          activeItem={activeTemplateId}
          isOpen={isProposalDialogOpen}
          isOpenChanged={() => setIsProposalDialogOpen(false)}
          unitIDsList={getCommaSeparatedIds(selectedUnitsCards)}
          parentTranslationPath={parentTranslationPath}
          translationPath={translationPath}
        />
      )}
      {isOpenFavouriteDialog && (
        <FavoriteDFM
          isOpen={isOpenFavouriteDialog}
          closeHandler={() => {
            setisOpenFavouritDialog(false);
            setActiveItem(null);
          }}
          parentTranslationPath={"ShareUnit"}
          translationPath=""
          FavoriteType="UNIT"
          AddTOlistView={viewType === "add-to-favourite" || false}
          checkedDetailed={checkedCards && checkedCards}
          Rest={() => {
            setActiveItem(null);
            setCheckedCards([]);
            setCheckedDetailedCards([]);
            onActionButtonChanged(ActionsButtonsEnum[1].id);
            setActionButtonsKey(generateUniqueKey());
          }}
          checkDesabled={checkedCards && checkedCards.length > 0}
          setfolderIdValue={(item) => {
            setfolderIdValue(item);
          }}
          setFilterfolderId={(item) => {
            SearchHandlerComponent(
              "FavoriteFolderId",
              `Favorite Folder  ${item.name || ""} ID  `,
              item.favoriteFolderId,
              300
            );
          }}
          GetAllDataInSearch={() => {}}
          reloadData={reloadData}
        />
      )}
      {isSelectTemplateOpen && (
        <DialogComponent
          titleText={"select-template"}
          translationPath={translationPath}
          parentTranslationPath={parentTranslationPath}
          isOpen={isSelectTemplateOpen}
          maxWidth={"sm"}
          onCloseClicked={() => setIsSelectTemplateOpen(false)}
          dialogContent={
            <SelectComponet
              data={templatesProposal}
              keyLoopBy="systemTemplateId"
              valueInput="systemTemplateId"
              textInput="systemTemplateName"
              wrapperClasses={"mb-2"}
              value={activeTemplateId}
              emptyItem={{
                value: null,
                text: "select-template",
                isDisabled: false,
              }}
              keyValue="actionsbuttons"
              idRef="contactsActionsRef"
              onSelectChanged={(value) => {
                setActiveTemplateId(value);
                if (value) {
                  setIsProposalDialogOpen(true);
                }
              }}
              translationPath={translationPath}
              translationPathForData={translationPath}
              parentTranslationPath={parentTranslationPath}
            />
          }
        />
      )}

      {isDialogRequestActivityOpen && (
        <RequestOfferLetterDialog
          isOpen={isDialogRequestActivityOpen}
          onClose={() => setIsDialogRequestActivityOpen(false)}
          translationPath="activities."
          parentTranslationPath="shared."
          unitData={activeCard}
          currentUser={JSON.parse(localStorage.getItem("session"))}
        />
      )}
      {isDialogPriceNegotiatioOpen && (
        <PriceNegotiationDialog
          isOpen={isDialogPriceNegotiatioOpen}
          onClose={() => setIsDialogPriceNegotiatioOpen(false)}
          translationPath="activities."
          parentTranslationPath="shared."
          unitData={activeCard}
          currentUser={JSON.parse(localStorage.getItem("session"))}
        />
      )}
      {ArchiveWizardDialog && (
        <ArchiveWizard
          isOpen={ArchiveWizardDialog}
          parentTranslationPath={parentTranslationPath}
          translationPath={translationPath}
          selectedLeads={[]}
          reloadData={reloadData}
          ArchiveWizardType="Unit"
          unitType="Lease"
           type={'UnitsLease'}
          onClose={() => {
            setArchiveWizardDialog(false);
            setActiveSelectedAction(ActionsButtonsEnum[1].id);
          }}
        />
      )}
    </>
  );
};
